<template>
  <div>
    <div class="d-flex" id="wrapper">
        <!-- Sidebar -->
        <SideBar/>
        <!-- /#sidebar-wrapper -->
        <!-- Page Content -->
        <div id="page-content-wrapper">
            <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
                <div>
                    <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                    </button>

                    <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                    </button>
                </div>
                <div class="d-flex">
                    <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
                    <p class="text-muted mb-0 hover-cursor link" @click="toPage('/partnership/lessee')">&nbsp;Lessee&nbsp;</p>
                    <p class="text-muted mb-0 hover-cursor link" @click="toPage('/partnership/lessee/verification')">/&nbsp;Verification&nbsp;</p>
                    <p class="text-primary mb-0 hover-cursor">/&nbsp;Details</p>
                </div>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{ admin }}
                            </a>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
            <div class="container-fluid">
                <div class="row mr-1">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <table>
                                        <tr>
                                            <th colspan="3" class="py-2">
                                                <h5> Company Info  <span class="link ml-2" @click="toggleEditCompanyInfo"><i class="fas fa-edit" data-toggle="tooltip" title="Edit"></i></span></h5>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>Name (Akta)</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ companyName }} <span v-if="newCompany" class="badge badge-primary">NEW</span> <img v-if="companyStatus == 8" src="~@/assets/images/icon-verified.png" alt="Brand Logo" class="icon-verified septian-font"></td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">Name (NPWP)</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td>
                                            {{ companyNameNPWP || '-' }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">Province</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td>{{ companyProvince }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">City</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td>{{ companyCity }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">District</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td>{{ companyDistrict }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">Village</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ companyVillage }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">Zip Code</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ companyZip }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">Address</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ companyAddress }}</td>
                                        </tr>
                                        <tr>
                                            <td>Phone</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ companyPhone }}</td>
                                        </tr>
                                        <tr>
                                            <td>Citizenship</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px; text-transform: uppercase;">{{ citizenship }}</td>
                                        </tr>
                                        <tr>
                                            <td v-if="citizenship == 'wni'">KTP Director</td>
                                            <td v-else>Passport Director</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td  style="word-wrap: break-word; max-width:200px;">{{ companyKtpPassportNumber }}</td>
                                        </tr>
                                        <tr>
                                            <td>NPWP</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ companyNPWP16 }}</td>
                                        </tr>
                                        <tr>
                                            <td>NITKU</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ companyNPWP22 }}</td>
                                        </tr>
                                        <tr>
                                            <td style="align-content: start;">Akta Address</td>
                                            <td style="align-content: start;">&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ aktaAddress }}</td>
                                        </tr>
                                        <tr>
                                            <td>Source</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ source }}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-lg-4 col-md-9 col-sm-12">
                                    <table>
                                        <tr>
                                            <th colspan="3" class="py-2"> 
                                                <h5> Company Person In Charge (PIC)</h5>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>Name</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ userName }}</td>
                                        </tr>
                                        <tr>
                                            <td>Phone</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ userPhone }}</td>
                                        </tr>
                                        <tr>
                                            <td>Email</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ userEmail }}</td>
                                        </tr>
                                        <tr>
                                            <td>Position</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ userPosition }}</td>
                                        </tr>
                                        <tr>
                                            <td>Division</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ userDivision }}</td>
                                        </tr>
                                    </table>
                                    <table class="mt-3">
                                        <tr>
                                            <th colspan="3" class="py-2"> 
                                                <h5>ASANI Person In Charge (PIC)</h5>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>Name</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td v-if="asaniEmployeeName != '' && asaniEmployeeName != null">{{ asaniEmployeeName }}</td>
                                            <td v-else>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                        </tr>
                                        
                                    </table>
                                    <table class="mt-3">
                                        <tr>
                                            <th colspan="3" class="py-2"> 
                                                <h5>Sales Status</h5>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span v-if="salesStatus == 1" class="badge badge-success">On Prospect</span>
                                                <span v-if="salesStatus == 2" class="badge badge-primary">On Going</span>
                                                <span v-if="salesStatus == 0" class="badge badge-warning">On Hold</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-lg-2 col-md-3 col-sm-12">
                                    <div class="py-1" v-if="companyLogoUrl != ''">
                                        <img class="img-logo" :src="companyLogoUrl">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mr-1">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="d-flex justify-content-between flex-wrap">
                                <div class="d-flex align-items-end flex-wrap">
                                    <div class="d-flex">
                                        <h5 class="card-title">History</h5> 
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-body" style="padding: 0.5rem">
                                    <span class="float-left"><b>NPWP/SKT</b>
                                        <span class="badge badge-secondary" v-if="NPWPStatus == 0"> Pending </span>
                                        <span class="badge badge-success" v-if="NPWPStatus == 1"> Approve </span>
                                        <span class="badge badge-danger" v-if="NPWPStatus == 2"> Reject </span>
                                    </span>
                                    <span class="float-right"><button class="btn btn-sm btn-primary" @click="toggleOpenChangeNPWPDoc">Upload</button></span>
                                </div>
                            </div>
                            <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                <thead>
                                    <tr>
                                        <th>Status</th>
                                        <th>Submit Date</th>
                                        <th>Submit By</th>
                                        <th>Action Date</th>
                                        <th>Action By</th>
                                        <th>Note</th>
                                        <th>Files</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="loadingTableNpwp == true">
                                        <td colspan="7" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                    </tr>
                                    <tr v-else-if="loadingTableNpwp == false && historyNpwp != ''" v-for="(data, index) in historyNpwp" :key="`npwpHist-${index}`">
                                      <td v-if="data.docStatus == 0"> Pending </td>
                                      <td v-if="data.docStatus == 1"> Approve </td>
                                      <td v-if="data.docStatus == 2"> Rejected </td>
                                      <td>{{ data.submitDate }}</td>
                                      <td>{{ data.submitBy }}</td>
                                      <td><span v-if="data.docStatus != 0">{{ data.actionDate }}</span></td>
                                      <td>{{ data.actionBy }}</td>
                                      <td>{{ data.note }}</td>
                                      <td class="text-center">
                                        <div v-if="data.docStatus == 0" @click="openModal('DocPending', 'NPWP/SKT', NPWPStatus)" class="link-text"> Update Status </div>
                                        <a :href="data.docUrl+'?token=' + jwt" target="_blank"> download </a></td>
                                    </tr>
                                    <tr v-else-if="loadingTableNpwp == false && historyNpwp == ''">
                                        <td colspan="7" class="text-center"> Data Not Available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row mr-1">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="card">
                                <div class="card-body" style="padding: 0.5rem">
                                    <span class="float-left"><b>SIUP</b>
                                        <span class="badge badge-secondary" v-if="siupStatus == 0"> Pending </span>
                                        <span class="badge badge-success" v-if="siupStatus == 1"> Approve </span>
                                        <span class="badge badge-danger" v-if="siupStatus == 2"> Reject </span>
                                    </span>
                                    <span class="float-right"><button class="btn btn-sm btn-primary" @click="openModal('ChangeDocument','SIUP')">Upload</button></span>
                                </div>
                            </div>
                            <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                <thead>
                                    <tr>
                                        <th>Status</th>
                                        <th>Submit Date</th>
                                        <th>Submit By</th>
                                        <th>Action Date</th>
                                        <th>Action By</th>
                                        <th>Note</th>
                                        <th>Files</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="loadingTableSiup == true">
                                        <td colspan="7" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                    </tr>
                                    <tr v-else-if="loadingTableSiup == false && historySiup != ''" v-for="(data, index) in historySiup" :key="`siupHist-${index}`">
                                      <td v-if="data.docStatus == 0"> Pending </td>
                                      <td v-if="data.docStatus == 1"> Approve </td>
                                      <td v-if="data.docStatus == 2"> Rejected </td>
                                      <td>{{ data.submitDate }}</td>
                                      <td>{{ data.submitBy }}</td>
                                      <td><span v-if="data.docStatus != 0">{{ data.actionDate }}</span></td>
                                      <td>{{ data.actionBy }}</td>
                                      <td>{{ data.note }}</td>
                                      <td class="text-center">
                                        <div v-if="data.docStatus == 0" @click="openModal('DocPending', 'SIUP', siupStatus)" class="link-text"> Update Status </div>
                                        <a :href="data.docUrl+'?token=' + jwt" target="_blank"> download </a></td>
                                    </tr>
                                    <tr v-else-if="loadingTableSiup == false && historySiup == ''">
                                        <td colspan="7" class="text-center"> Data Not Available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row mr-1">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="card">
                                <div class="card-body" style="padding: 0.5rem">
                                    <span class="float-left"><b>Akta Pendirian</b>
                                        <span class="badge badge-secondary" v-if="aktaStatus == 0"> Pending </span>
                                        <span class="badge badge-success" v-if="aktaStatus == 1"> Approve </span>
                                        <span class="badge badge-danger" v-if="aktaStatus == 2"> Reject </span>
                                    </span>
                                    <span class="float-right"><button class="btn btn-sm btn-primary" @click="openModal('ChangeDocument','Akta')">Upload</button></span>
                                </div>
                            </div>
                            <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                <thead>
                                    <tr>
                                        <th>Status</th>
                                        <th>Submit Date</th>
                                        <th>Submit By</th>
                                        <th>Action Date</th>
                                        <th>Action By</th>
                                        <th>Note</th>
                                        <th>Files</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="loadingTableAkta == true">
                                        <td colspan="7" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                    </tr>
                                    <tr v-else-if="loadingTableAkta == false && historyAkta != ''" v-for="(data, index) in historyAkta" :key="`aktaHist-${index}`">
                                      <td v-if="data.docStatus == 0"> Pending </td>
                                      <td v-if="data.docStatus == 1"> Approve </td>
                                      <td v-if="data.docStatus == 2"> Rejected </td>
                                      <td>{{ data.submitDate }}</td>
                                      <td>{{ data.submitBy }}</td>
                                      <td><span v-if="data.docStatus != 0">{{ data.actionDate }}</span></td>
                                      <td>{{ data.actionBy }}</td>
                                      <td>{{ data.note }}</td>
                                      <td class="text-center">
                                        <div v-if="data.docStatus == 0" @click="openModal('DocPending', 'Akta', aktaStatus)" class="link-text"> Update Status </div>
                                        <a :href="data.docUrl+'?token=' + jwt" target="_blank"> download </a></td>
                                    </tr>
                                    <tr v-else-if="loadingTableAkta == false && historyAkta == ''">
                                        <td colspan="7" class="text-center"> Data Not Available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row mr-1" v-if="historyAktaPerubahan.length > 0">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="card">
                                <div class="card-body" style="padding: 0.5rem">
                                    <span class="float-left"><b>Akta Perubahan</b>
                                        <span class="badge badge-secondary" v-if="aktaPerubahanStatus == 0"> Pending </span>
                                        <span class="badge badge-success" v-if="aktaPerubahanStatus == 1"> Approve </span>
                                        <span class="badge badge-danger" v-if="aktaPerubahanStatus == 2"> Reject </span>
                                    </span>
                                    <span class="float-right"><button class="btn btn-sm btn-primary" @click="openModal('ChangeDocument','Akta Perubahan')">Upload</button></span>
                                </div>
                            </div>
                            <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                <thead>
                                    <tr>
                                        <th>Status</th>
                                        <th>Submit Date</th>
                                        <th>Submit By</th>
                                        <th>Action Date</th>
                                        <th>Action By</th>
                                        <th>Note</th>
                                        <th>Files</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="loadingTableAkta == true">
                                        <td colspan="7" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                    </tr>
                                    <tr v-else-if="loadingTableAkta == false && historyAkta != ''" v-for="(data, index) in historyAktaPerubahan" :key="`perubahanAktaHist-${index}`">
                                      <td v-if="data.docStatus == 0"> Pending </td>
                                      <td v-if="data.docStatus == 1"> Approve </td>
                                      <td v-if="data.docStatus == 2"> Rejected </td>
                                      <td>{{ data.submitDate }}</td>
                                      <td>{{ data.submitBy }}</td>
                                      <td><span v-if="data.docStatus != 0">{{ data.actionDate }}</span></td>
                                      <td>{{ data.actionBy }}</td>
                                      <td>{{ data.note }}</td>
                                      <td class="text-center">
                                        <div v-if="data.docStatus == 0" @click="openModal('DocPending', 'Akta Perubahan', aktaPerubahanStatus)" class="link-text"> Update Status </div>
                                        <a :href="data.docUrl+'?token=' + jwt" target="_blank"> download </a></td>
                                    </tr>
                                    <tr v-else-if="loadingTableAkta == false && historyAktaPerubahan == ''">
                                        <td colspan="7" class="text-center"> Data Not Available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row mr-1">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="card">
                                <div class="card-body" style="padding: 0.5rem">
                                    <span class="float-left">
                                        <b v-if="citizenship == 'wni'">KTP Director</b>
                                        <b v-else>Passport Director</b>
                                        <span class="badge badge-secondary" v-if="companyKTPStatus == 0"> Pending </span>
                                        <span class="badge badge-success" v-if="companyKTPStatus == 1"> Approve </span>
                                        <span class="badge badge-danger" v-if="companyKTPStatus == 2"> Reject </span>
                                    </span>
                                    <span class="float-right"><button class="btn btn-sm btn-primary" @click="openModal('ChangeDocument','KTP')">Upload</button></span>
                                </div>
                            </div>
                            <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                <thead>
                                    <tr>
                                        <th>Status</th>
                                        <th>Submit Date</th>
                                        <th>Submit By</th>
                                        <th>Action Date</th>
                                        <th>Action By</th>
                                        <th>Note</th>
                                        <th>Files</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="loadingTableKtp == true">
                                        <td colspan="7" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                    </tr>
                                    <tr v-else-if="loadingTableKtp == false && historyKtp != ''" v-for="(data, index) in historyKtp" :key="`ktpHist-${index}`">
                                      <td v-if="data.docStatus == 0"> Pending </td>
                                      <td v-if="data.docStatus == 1"> Approve </td>
                                      <td v-if="data.docStatus == 2"> Rejected </td>
                                      <td>{{ data.submitDate }}</td>
                                      <td>{{ data.submitBy }}</td>
                                      <td><span v-if="data.docStatus != 0">{{ data.actionDate }}</span></td>
                                      <td>{{ data.actionBy }}</td>
                                      <td>{{ data.note }}</td>
                                      <td class="text-center">
                                        <div v-if="data.docStatus == 0" @click="openModal('DocPending', 'KTP', companyKTPStatus)" class="link-text"> Update Status </div>
                                        <a :href="data.docUrl+'?token=' + jwt" target="_blank"> download </a></td>
                                    </tr>
                                    <tr v-else-if="loadingTableKtp == false && historyKtp == ''">
                                        <td colspan="7" class="text-center"> Data Not Available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row mr-1">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="card">
                                <div class="card-body" style="padding: 0.5rem">
                                    <span class="float-left"><b>SK Menkumham Pendirian</b>
                                        <span class="badge badge-secondary" v-if="SKStatus == 0"> Pending </span>
                                        <span class="badge badge-success" v-if="SKStatus == 1"> Approve </span>
                                        <span class="badge badge-danger" v-if="SKStatus == 2"> Reject </span>
                                    </span>
                                    <span class="float-right"><button class="btn btn-sm btn-primary" @click="openModal('ChangeDocument','SK Menkumham')">Upload</button></span>
                                </div>
                            </div>
                            <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                <thead>
                                    <tr>
                                        <th>Status</th>
                                        <th>Submit Date</th>
                                        <th>Submit By</th>
                                        <th>Action Date</th>
                                        <th>Action By</th>
                                        <th>Note</th>
                                        <th>Files</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="loadingTableSk == true">
                                        <td colspan="7" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                    </tr>
                                    <tr v-else-if="loadingTableSk == false && historySk != ''" v-for="(data, index) in historySk" :key="`skHist-${index}`">
                                      <td v-if="data.docStatus == 0"> Pending </td>
                                      <td v-if="data.docStatus == 1"> Approve </td>
                                      <td v-if="data.docStatus == 2"> Rejected </td>
                                      <td>{{ data.submitDate }}</td>
                                      <td>{{ data.submitBy }}</td>
                                      <td><span v-if="data.docStatus != 0">{{ data.actionDate }}</span></td>
                                      <td>{{ data.actionBy }}</td>
                                      <td>{{ data.note }}</td>
                                      <td class="text-center">
                                        <div v-if="data.docStatus == 0" @click="openModal('DocPending', 'SK Menkumham', SKStatus)" class="link-text"> Update Status </div>
                                        <a :href="data.docUrl+'?token=' + jwt" target="_blank"> download </a></td>
                                    </tr>
                                    <tr v-else-if="loadingTableSk == false && historySk == ''">
                                        <td colspan="7" class="text-center"> Data Not Available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- SK perubahan -->
                <div class="row mr-1" v-if="historySkPerubahan.length > 0">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="card">
                                <div class="card-body" style="padding: 0.5rem">
                                    <span class="float-left"><b>SK Menkumham Perubahan</b>
                                        <span class="badge badge-secondary" v-if="SKPerubahanStatus == 0"> Pending </span>
                                        <span class="badge badge-success" v-if="SKPerubahanStatus == 1"> Approve </span>
                                        <span class="badge badge-danger" v-if="SKPerubahanStatus == 2"> Reject </span>
                                    </span>
                                    <span class="float-right"><button class="btn btn-sm btn-primary" @click="openModal('ChangeDocument','SK Menkumham Perubahan')">Upload</button></span>
                                </div>
                            </div>
                            <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                <thead>
                                    <tr>
                                        <th>Status</th>
                                        <th>Submit Date</th>
                                        <th>Submit By</th>
                                        <th>Action Date</th>
                                        <th>Action By</th>
                                        <th>Note</th>
                                        <th>Files</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="loadingTableSk == true">
                                        <td colspan="7" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                    </tr>
                                    <tr v-else-if="loadingTableSk == false && historySk != ''" v-for="(data, index) in historySkPerubahan" :key="`skPerubahanHist-${index}`">
                                      <td v-if="data.docStatus == 0"> Pending </td>
                                      <td v-if="data.docStatus == 1"> Approve </td>
                                      <td v-if="data.docStatus == 2"> Rejected </td>
                                      <td>{{ data.submitDate }}</td>
                                      <td>{{ data.submitBy }}</td>
                                      <td><span v-if="data.docStatus != 0">{{ data.actionDate }}</span></td>
                                      <td>{{ data.actionBy }}</td>
                                      <td>{{ data.note }}</td>
                                      <td class="text-center">
                                        <div v-if="data.docStatus == 0" @click="openModal('DocPending', 'SK Menkumham Perubahan', SKPerubahanStatus)" class="link-text"> Update Status </div>
                                        <a :href="data.docUrl+'?token=' + jwt" target="_blank"> download </a></td>
                                    </tr>
                                    <tr v-else-if="loadingTableSk == false && historySkPerubahan == ''">
                                        <td colspan="7" class="text-center"> Data Not Available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /#page-content-wrapper -->
    </div>
    <!-- endModal -->
    <!-- modalEditCompany -->
    <div class="modal fade" id="modalEditPIC" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Edit Person In Charge (PIC)</h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="one-line">
                        <label class="ol-label"> Name </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm" v-model="editUserName">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Phone </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm" v-model="editUserPhone" @keypress="isNumber($event)" placeholder="Ex :628xxxxxxxxxxxx">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Email </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm" v-model="editUserEmail">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Position </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm" v-model="editUserPosition">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Division </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm" v-model="editUserDivision">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="submitEditPic" v-if="loadingButtonSave == false">Save</button>
                    <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
                </div>
            </div>
        </div>
    </div>
    <!-- endModal -->
    <!-- Modal Edit-->
    <div class="modal fade" id="modalDelete" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Delete Admin</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <p>Are you sure to delete Admin (ini nama admin) ?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm">Save</button>
            </div>
          </div>
        </div>
    </div>
    <!-- endModal -->
    <!-- modalReject -->
      <div class="modal fade" id="modalChangeDocument" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Change Document {{ docPilih === "KTP" && citizenship == "wna"? 'Passport': docPilih }}</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="one-line">
                    <label class="ol-label-file"> Document File </label>
                    <label class="ol-titik2-file">:</label>
                    <input type="file" :ref="docPilih" name="" id="change_document" @change="onFilePicked($event, docPilih)">
                </div>
                <div class="one-line" v-if="docPilih == 'Akta'">
                    <label class="ol-label"> Akta Address </label>
                    <label class="ol-titik2">:</label>
                    <input type="text" class="form-control-sm form-control" name="akta" v-model="aktaAdressInput">
                </div>
                <div class="one-line" v-if="docPilih == 'KTP'">
                    <label class="ol-label"> {{ citizenship == 'wni'? "No. KTP": "No. Passport"}} </label>
                    <label class="ol-titik2">:</label>
                    <input type="text" class="form-control-sm form-control" name="ktp" @keypress="citizenship == 'wni'? isNumber($event): undefined" v-model="uploadKTPNumber">
                </div>
                <div class="one-line">
                    <label class="ol-label"> Note </label>
                    <label class="ol-titik2">:</label>
                    <textarea rows="3" class="form-control form-control-sm" v-model="noteChangeDocument" style="resize: none"></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary btn-sm" @click="submitDoc" v-if="loadingButtonSave == false">Save</button>
                <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->

      <!-- MODAL DOCUMENTS -->
      <!-- Modal DocPending-->
    <div class="modal fade" id="modalDocPending" role="dialog">
        <div class="modal-dialog modal-md modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Document {{ docPilih === "KTP" && citizenship == "wna"? 'Passport': docPilih }}</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="one-line" v-if="docPilih == 'KTP' && companyKTPStatus == 0 && docStatus != 2">
                <label class="ol-label"> {{ citizenship == 'wni'? "No. KTP": "No. Passport"}} </label>
                <label class="ol-titik2">:</label>
                <input type="text" class="form-control-sm form-control" name="ktp" @keypress="citizenship == 'wni'? isNumber($event): undefined" v-model="KTPNumber">
              </div>
              <div class="one-line" v-if="docPilih == 'KTP' && companyKTPStatus == 0">
                <label class="ol-label"> Status</label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm" v-model="docStatus">
                    <option value="0">None</option>
                    <option value="1">Approve</option>
                    <option value="2">Reject</option>
                </select>
              </div>
              <div class="one-line" v-if="docPilih == 'NPWP/SKT' && NPWPStatus == 0 && docStatus != 2">
                <label class="ol-label"> NPWP Number</label>
                <label class="ol-titik2">:</label>
                <input type="text" class="form-control-sm form-control" name="ktp" @keypress="isNumber($event)" v-model="NpwpDocInput">
              </div>
              <div class="one-line" v-if="docPilih == 'NPWP/SKT' && NPWPStatus == 0">
                <label class="ol-label"> Status</label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm" v-model="docStatus">
                    <option value="0">None</option>
                    <option value="1">Approve</option>
                    <option value="2">Reject</option>
                </select>
              </div>
              <div class="one-line" v-if="docPilih == 'SIUP' && siupStatus == 0">
                <label class="ol-label"> Status</label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm" v-model="docStatus">
                    <option value="0">None</option>
                    <option value="1">Approve</option>
                    <option value="2">Reject</option>
                </select>
              </div>
              <div class="one-line" v-if="docPilih == 'SK Menkumham' && SKStatus == 0">
                <label class="ol-label"> Status</label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm" v-model="docStatus">
                    <option value="0">None</option>
                    <option value="1">Approve</option>
                    <option value="2">Reject</option>
                </select>
              </div>
              <div class="one-line" v-if="docPilih == 'SK Menkumham Perubahan' && SKPerubahanStatus == 0">
                <label class="ol-label"> Status</label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm" v-model="docStatus">
                    <option value="0">None</option>
                    <option value="1">Approve</option>
                    <option value="2">Reject</option>
                </select>
              </div>
              <div class="one-line" v-if="docPilih == 'Purchase Order' && purchaseStatus == 0">
                <label class="ol-label"> Status</label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm" v-model="docStatus">
                    <option value="0">None</option>
                    <option value="1">Approve</option>
                    <option value="2">Reject</option>
                </select>
              </div>
              <div class="one-line" v-if="docPilih == 'Akta' && aktaStatus == 0 && docStatus != 2">
                <label class="ol-label"> Akta Address </label>
                <label class="ol-titik2">:</label>
                <input type="text" class="form-control-sm form-control" name="ktp" v-model="aktaAdressInput">
              </div>
              <div class="one-line" v-if="docPilih == 'Akta Perubahan' && aktaPerubahanStatus == 0 && docStatus != 2">
                <label class="ol-label"> Akta Address </label>
                <label class="ol-titik2">:</label>
                <input type="text" class="form-control-sm form-control" name="ktp" v-model="aktaAdressInput">
              </div>
              <div class="one-line" v-if="docPilih == 'Akta' && aktaStatus == 0">
                <label class="ol-label"> Status</label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm" v-model="docStatus">
                    <option value="0">None</option>
                    <option value="1">Approve</option>
                    <option value="2">Reject</option>
                </select>
              </div>
              <div class="one-line" v-if="docPilih == 'Akta Perubahan' && aktaPerubahanStatus == 0">
                <label class="ol-label"> Status</label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm" v-model="docStatus">
                    <option value="0">None</option>
                    <option value="1">Approve</option>
                    <option value="2">Reject</option>
                </select>
              </div>
              <div class="one-line" v-if="(docPilih == 'NPWP/SKT' && NPWPStatus == 0 && docStatus != 0) || (docPilih == 'SIUP' && siupStatus == 0 && docStatus != 0) || (docPilih == 'SK Menkumham' && SKStatus == 0 && docStatus != 0) || (docPilih == 'SK Menkumham Perubahan' && SKPerubahanStatus == 0 && docStatus != 0) || (docPilih == 'Akta' && aktaStatus == 0 && docStatus != 0) || (docPilih == 'Akta Perubahan' && aktaPerubahanStatus == 0 && docStatus != 0) || docPilih == 'KTP' && companyKTPStatus == 0 && docStatus != 0">
                <label class="ol-label"> Reason</label>
                <label class="ol-titik2">:</label>
                <textarea rows="3" class="form-control form-control-sm" v-model="rejectReason" style="resize: none;"></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" v-if="(docPilih == 'KTP' && companyKTPStatus == 0) || (docPilih == 'NPWP/SKT' && NPWPStatus == 0) || (docPilih == 'Akta' && aktaStatus == 0) || (docPilih == 'Akta Perubahan' && aktaPerubahanStatus == 0) || (docPilih == 'SIUP' && siupStatus == 0) || (docPilih == 'SK Menkumham' && SKStatus == 0) || (docPilih == 'SK Menkumham Perubahan' && SKPerubahanStatus == 0)">Cancel</button>

              <button type="button" class="btn btn-primary btn-sm" @click="updateDocStatus(docPilih)" v-if="(docPilih == 'KTP' && companyKTPStatus == 0 && loadingButtonProcess == false) || (docPilih == 'NPWP/SKT' && NPWPStatus == 0 && loadingButtonProcess == false) || (docPilih == 'SIUP' && siupStatus == 0 && loadingButtonProcess == false) || (docPilih == 'Akta' && aktaStatus == 0 && loadingButtonProcess == false) || (docPilih == 'SK Menkumham' && SKStatus == 0 && loadingButtonProcess == false) || (docPilih == 'Akta Perubahan' && aktaPerubahanStatus == 0 && loadingButtonProcess == false) || (docPilih == 'SK Menkumham Perubahan' && SKPerubahanStatus == 0 && loadingButtonProcess == false)">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonProcess == true"><img src="~@/assets/images/2.gif" style="height: 24px;">Save</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- Modal Edit-->
    <div class="modal fade" id="modalContacting" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Contacting</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div v-if="lastStatus != 1 && lastStatus != 99 && companyStatus != 99">
                    <div class="one-line">
                        <label class="ol-label"> Choose Channel </label>
                        <label class="ol-titik2">:</label>
                        <select class="form-control form-control-sm" v-model="channel" placeholder="Choose Channel">
                            <option value="">Choose Channel</option>
                            <option value="Call">Call</option>
                            <option value="WhatsApp">WhatsApp</option>
                            <option value="Email">Email</option>
                        </select>
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Date </label>
                        <label class="ol-titik2">:</label>
                        <date-picker style="width: 100%" v-model="contactingDate" type="date" format="DD-MM-YYYY" placeholder="Select Date"></date-picker>
                        <!-- <input type="datetime-local" name="schedule" v-model="meetingSchedule" class="form-control form-control-sm"> -->
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Note </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="note" class="form-control-sm form-control" v-model="noteContacting">
                    </div>
                </div>
                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                    <thead>
                        <tr>
                            <th>Attemp</th>
                            <th>Channel</th>
                            <th>Date</th>
                            <th>Action Date</th>
                            <th>Action By</th>
                            <th>Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loadingTable">
                            <td colspan="5" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                        </tr>
                        <tr v-else-if="dataContacting == '' && !loadingTable">
                            <td colspan="5" class="text-center">Data not available</td>
                        </tr>
                        <tr v-else v-for="(data,index) in dataContacting" :key="`contacting-${index}`">
                            <td>{{ index+1 }}</td>
                            <td>{{ data.channel }}</td>
                            <td>{{ data.date }}</td>
                            <td>{{ data.actionDate }}</td>
                            <td>{{ data.actionBy }}</td>
                            <td>{{ data.note }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" v-if="lastStatus != 1 && lastStatus != 99 && companyStatus != 99">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="submitContacting" v-if="!loadingButtonSave && lastStatus != 1 && lastStatus != 99 && companyStatus != 99">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonSave && lastStatus != 1 && lastStatus != 99 && companyStatus != 99"><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
            </div>
          </div>
        </div>
    </div>
    <!-- endModal -->
    <div class="modal fade" id="modalMeeting" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Meeting</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div v-if="lastStatus != 1 && lastStatus != 99 && companyStatus != 99">
                    <div class="one-line" v-if="lastStatus != null">
                        <label class="ol-label"> Status </label>
                        <label class="ol-titik2">:</label>
                        <select class="form-control form-control-sm" v-model="meetingStatus" placeholder="Choose Channel">
                            <option value="">Choose Status</option>
                            <option value="1">Done</option>
                            <option value="2">Reschedule</option>
                            <option value="99">Cancel</option>
                        </select>
                    </div>

                    <div class="one-line" v-if="lastStatus == null || meetingStatus == 2">
                        <label class="ol-label"> Set Schedule </label>
                        <label class="ol-titik2">:</label>
                        <date-picker style="width: 100%" v-model="meetingSchedule" type="datetime" format="DD-MM-YYYY HH:mm" placeholder="Select Date and Time"></date-picker>
                        <!-- <input type="datetime-local" name="schedule" v-model="meetingSchedule" class="form-control form-control-sm"> -->
                    </div>
                    <div class="one-line" v-if="(lastStatus != null || meetingStatus == 99) && meetingStatus != 1">
                        <label class="ol-label"> Reason </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="place" class="form-control-sm form-control" v-model="reasonMeeting">
                    </div>

                    <div class="one-line" v-if="lastStatus == null || meetingStatus == 2">
                        <label class="ol-label"> Place </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="place" class="form-control-sm form-control" v-model="meetingPlace">
                    </div>

                    <div class="one-line" v-if="lastStatus == null || meetingStatus == 2">
                        <label class="ol-label"> Note </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="note" class="form-control-sm form-control" v-model="noteMeeting">
                    </div>

                    <div class="one-line" v-if="lastStatus != null && meetingStatus == 1">
                        <label class="ol-label">Meeting Address </label>
                        <label class="ol-titik2">:</label>
                        <textarea class="form-control" rows="3" style="resize: none" v-model="meetingAddress"></textarea>
                    </div>

                    <div class="one-line" v-if="lastStatus != null && meetingStatus == 1">
                        <label class="ol-label"> Agenda </label>
                        <label class="ol-titik2">:</label>
                        <textarea class="form-control" rows="3" style="resize: none" v-model="meetingAgenda"></textarea>
                    </div>

                    
                    <div v-for="(input, index) in inputAsaniAttend" :key="index">
                        <div class="one-line" v-if="lastStatus != null && meetingStatus == 1">
                            <label class="ol-label"> 
                                <span v-if="index == 0"> Asani Attendant </span>
                            </label>
                            <label class="ol-titik2">
                                <span v-if="index == 0">:</span>
                            </label>
                            <div style="width: 100%; display: flex;">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="employeeName[index]" style="width: 30%" placeholder="Name"> as
                                <input type="text" name="reason" class="form-control-sm form-control ml-1" v-model="employeePosition[index]" style="width: 30%" placeholder="Position"> 
                                <button class="btn btn-sm btn-primary ml-2" @click="addAttend('Asani')" v-if="index == 0"><i class="fas fa-plus"></i></button>
                                <button class="btn btn-sm btn-danger ml-2" @click="removeRow('Asani',index)" v-if="index != 0"><i class="fas fa-trash"></i></button>
                            </div>
                        </div>
                    </div>

                    <div v-for="(input, index) in inputClientAttend" :key="`client-${index}`">
                        <div class="one-line" v-if="lastStatus != null && meetingStatus == 1">
                            <label class="ol-label"> 
                                <span v-if="index == 0"> Client Attendant </span>
                            </label>
                            <label class="ol-titik2">
                                <span v-if="index == 0">:</span>
                            </label>
                            <div style="width: 100%; display: flex;">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="clientName[index]" style="width: 30%" placeholder="Name"> as
                                <input type="text" name="reason" class="form-control-sm form-control ml-1" v-model="clientPosition[index]" style="width: 30%" placeholder="Position"> 
                                <button class="btn btn-sm btn-primary ml-2" @click="addAttend('Client')" v-if="index == 0"><i class="fas fa-plus"></i></button>
                                <button class="btn btn-sm btn-danger ml-2" @click="removeRow('Client',index)" v-if="index != 0"><i class="fas fa-trash"></i></button>
                            </div>
                        </div>
                    </div>

                    <div class="one-line" v-if="lastStatus != null && meetingStatus == 1">
                        <label class="ol-label"> Company Profile </label>
                        <label class="ol-titik2">:</label>
                        <div class="row" style="width: 100%; margin-left: 0px; padding-left: 0px">
                            <div class="col-12" style="display: flex; margin-left: 0px; padding-left: 0px">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="companySince" style="width: 30%" placeholder="Founded since" @keypress="isNumber($event)">
                                <input type="text" name="reason" class="form-control-sm form-control ml-3" v-model="totalEmployeeClient" style="width: 30%" placeholder="Number of employee" @keypress="isNumber($event)"> 
                            </div>
                            <div class="col-12 mt-2" style="margin-left: 0px; padding-left: 0px">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="industryType" style="width: 30%" placeholder="Industry type">
                            </div>
                        </div>
                    </div>

                    <div v-if="lastStatus != null && meetingStatus == 1" class="mt-3">
                        <label class="ol-label"> Meeting Result </label>
                        <br>
                        <textarea class="form-control" rows="5" style="resize: none" v-model="meetingResult"></textarea>
                    </div>

                    <div v-if="lastStatus != null && meetingStatus == 1" class="mt-3">
                        <label class="ol-label"> List to do Asani </label>
                        <br>
                        <textarea class="form-control" rows="5" style="resize: none" v-model="listToDo"></textarea>
                    </div>
                    <div v-if="lastStatus != null && meetingStatus == 1" class="mt-3">
                        <label class="ol-label"> Visit Documentation </label>
                        <br>
                        <input type="file" id="visit_0" name="" class="mt-2 form-control-file" @change="onFileDocPicked($event,0)">
                        <input type="file" id="visit_1" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,1)">
                        <input type="file" id="visit_2" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,2)">
                        <input type="file" id="visit_3" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,3)">
                        <input type="file" id="visit_4" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,4)">
                    </div>
                </div>
                <div v-if="editMeeting">
                    <div class="one-line" v-if="lastStatus != null">
                        <label class="ol-label">Meeting Address </label>
                        <label class="ol-titik2">:</label>
                        <textarea class="form-control" rows="3" style="resize: none" v-model="meetingAddress"></textarea>
                    </div>

                    <div class="one-line" v-if="lastStatus != null">
                        <label class="ol-label"> Agenda </label>
                        <label class="ol-titik2">:</label>
                        <textarea class="form-control" rows="3" style="resize: none" v-model="meetingAgenda"></textarea>
                    </div>

                    
                    <div v-for="(input, index) in inputAsaniAttend" :key="index">
                        <div class="one-line" v-if="lastStatus != null">
                            <label class="ol-label"> 
                                <span v-if="index == 0"> Asani Attendant </span>
                            </label>
                            <label class="ol-titik2">
                                <span v-if="index == 0">:</span>
                            </label>
                            <div style="width: 100%; display: flex;">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="employeeName[index]" style="width: 30%" placeholder="Name"> as
                                <input type="text" name="reason" class="form-control-sm form-control ml-1" v-model="employeePosition[index]" style="width: 30%" placeholder="Position"> 
                                <button class="btn btn-sm btn-primary ml-2" @click="addAttend('Asani')" v-if="index == 0"><i class="fas fa-plus"></i></button>
                                <button class="btn btn-sm btn-danger ml-2" @click="removeRow('Asani',index)" v-if="index != 0"><i class="fas fa-trash"></i></button>
                            </div>
                        </div>
                    </div>

                    <div v-for="(input, index) in inputClientAttend" :key="`client-${index}`">
                        <div class="one-line" v-if="lastStatus != null">
                            <label class="ol-label"> 
                                <span v-if="index == 0"> Client Attendant </span>
                            </label>
                            <label class="ol-titik2">
                                <span v-if="index == 0">:</span>
                            </label>
                            <div style="width: 100%; display: flex;">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="clientName[index]" style="width: 30%" placeholder="Name"> as
                                <input type="text" name="reason" class="form-control-sm form-control ml-1" v-model="clientPosition[index]" style="width: 30%" placeholder="Position"> 
                                <button class="btn btn-sm btn-primary ml-2" @click="addAttend('Client')" v-if="index == 0"><i class="fas fa-plus"></i></button>
                                <button class="btn btn-sm btn-danger ml-2" @click="removeRow('Client',index)" v-if="index != 0"><i class="fas fa-trash"></i></button>
                            </div>
                        </div>
                    </div>

                    <div class="one-line" v-if="lastStatus != null">
                        <label class="ol-label"> Company Profile </label>
                        <label class="ol-titik2">:</label>
                        <div class="row" style="width: 100%; margin-left: 0px; padding-left: 0px">
                            <div class="col-12" style="display: flex; margin-left: 0px; padding-left: 0px">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="companySince" style="width: 30%" placeholder="Founded since">
                                <input type="text" name="reason" class="form-control-sm form-control ml-3" v-model="totalEmployeeClient" style="width: 30%" placeholder="Number of employee"> 
                            </div>
                            <div class="col-12 mt-2" style="margin-left: 0px; padding-left: 0px">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="industryType" style="width: 30%" placeholder="Industry type">
                            </div>
                        </div>
                    </div>

                    <div v-if="lastStatus != null" class="mt-3">
                        <label class="ol-label"> Meeting Result </label>
                        <br>
                        <textarea class="form-control" rows="5" style="resize: none" v-model="meetingResult"></textarea>
                    </div>

                    <div v-if="lastStatus != null" class="mt-3">
                        <label class="ol-label"> List to do Asani </label>
                        <br>
                        <textarea class="form-control" rows="5" style="resize: none" v-model="listToDo"></textarea>
                    </div>
                    <div v-if="lastStatus != null" class="mt-3">
                        <label class="ol-label"> Visit Documentation </label>
                        <br>
                        <input type="file" id="visit_0" name="" class="mt-2 form-control-file" @change="onFileDocPicked($event,0)">
                        <div v-if="visitDocumentation[0].fileUrl != ''">
                            <a class="link-biru" :href="visitDocumentation[0].fileUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                        </div>
                        <input type="file" id="visit_1" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,1)">
                        <div v-if="visitDocumentation[1].fileUrl != ''">
                            <a class="link-biru" :href="visitDocumentation[1].fileUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                        </div>
                        <input type="file" id="visit_2" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,2)">
                        <div v-if="visitDocumentation[2].fileUrl != ''">
                            <a class="link-biru" :href="visitDocumentation[2].fileUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                        </div>
                        <input type="file" id="visit_3" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,3)">
                        <div v-if="visitDocumentation[3].fileUrl != ''">
                            <a class="link-biru" :href="visitDocumentation[3].fileUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                        </div>
                        <input type="file" id="visit_4" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,4)">
                        <div v-if="visitDocumentation[4].fileUrl != ''">
                            <a class="link-biru" :href="visitDocumentation[4].fileUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                        </div>
                    </div>
                </div>
                <div v-if="lastStatus == 1 && !editMeeting">
                    <div class="card" style="display: flow-root; padding: 5px" data-toggle="collapse" href="#collapseInfo" role="button" aria-expanded="false" aria-controls="collapseInfo">
                            <div class="float-left"> Info</div>
                            <div class="float-right"><i class="fas fa-chevron-circle-down"></i></div>
                    </div>
                            <div class="collapse" id="collapseInfo">
                                <div class="one-line" v-if="lastStatus == 1">
                                    <label class="ol-label">Meeting Address </label>
                                    <label class="ol-titik2">:</label>
                                    <textarea class="form-control" rows="3" style="resize: none" v-model="editMeetingAddress" readonly></textarea>
                                </div>

                                <div class="one-line" v-if="lastStatus == 1">
                                    <label class="ol-label"> Agenda </label>
                                    <label class="ol-titik2">:</label>
                                    <textarea class="form-control" rows="3" style="resize: none" v-model="editMeetingAgenda" readonly></textarea>
                                </div>

                                
                                <div v-for="(input, index) in editInputAsaniAttend" :key="index">
                                    <div class="one-line" v-if="lastStatus == 1">
                                        <label class="ol-label"> 
                                            <span v-if="index == 0"> Asani Attendant </span>
                                        </label>
                                        <label class="ol-titik2">
                                            <span v-if="index == 0">:</span>
                                        </label>
                                        <div style="width: 100%; display: flex;">
                                            <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="editEmployeeName[index]" style="width: 30%" placeholder="Name" readonly> as
                                            <input type="text" name="reason" class="form-control-sm form-control ml-1" v-model="editEmployeePosition[index]" style="width: 30%" placeholder="Position" readonly> 
                                        </div>
                                    </div>
                                </div>

                                <div v-for="(input, index) in editInputClientAttend" :key="`client-${index}`">
                                    <div class="one-line" v-if="lastStatus == 1">
                                        <label class="ol-label"> 
                                            <span v-if="index == 0"> Client Attendant </span>
                                        </label>
                                        <label class="ol-titik2">
                                            <span v-if="index == 0">:</span>
                                        </label>
                                        <div style="width: 100%; display: flex;">
                                            <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="editClientName[index]" style="width: 30%" placeholder="Name" readonly> as
                                            <input type="text" name="reason" class="form-control-sm form-control ml-1" v-model="editClientPosition[index]" style="width: 30%" placeholder="Position" readonly> 
                                        </div>
                                    </div>
                                </div>

                                <div class="one-line" v-if="lastStatus == 1">
                                    <label class="ol-label"> Company Profile </label>
                                    <label class="ol-titik2">:</label>
                                    <div class="row" style="width: 100%; margin-left: 0px; padding-left: 0px">
                                        <div class="col-12" style="display: flex; margin-left: 0px; padding-left: 0px">
                                            <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="editCompanySince" style="width: 30%" placeholder="Founded since" readonly>
                                            <input type="text" name="reason" class="form-control-sm form-control ml-3" v-model="editTotalEmployeeClient" style="width: 30%" placeholder="Number of employee" readonly> 
                                        </div>
                                        <div class="col-12 mt-2" style="margin-left: 0px; padding-left: 0px">
                                            <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="editIndustryType" style="width: 30%" placeholder="Industry type" readonly>
                                        </div>
                                    </div>
                                </div>
                            </div>
                </div>
                <div v-if="lastStatus == 1 && !editMeeting" class="mt-3">
                    <div class="card" style="display: flow-root; padding: 5px" data-toggle="collapse" href="#collapseResult" role="button" aria-expanded="false" aria-controls="collapseResult">
                    <div class="float-left"> Meeting Result</div>
                    <div class="float-right"><i class="fas fa-chevron-circle-down"></i></div>
                    </div>
                    <div class="collapse" id="collapseResult">
                        <textarea class="form-control" rows="5" style="resize: none" v-model="editMeetingResult" readonly></textarea>
                    </div>
                </div>

                <div v-if="lastStatus == 1 && !editMeeting" class="mt-3">
                    <div class="card" style="display: flow-root; padding: 5px" data-toggle="collapse" href="#collapseList" role="button" aria-expanded="false" aria-controls="collapseList">
                    <div class="float-left"> List to do Asani</div>
                    <div class="float-right"><i class="fas fa-chevron-circle-down"></i></div>
                    </div>
                    <div class="collapse" id="collapseList">
                        <textarea class="form-control" rows="5" style="resize: none" v-model="editListToDo" readonly></textarea>
                    </div>
                </div>
                <div v-if="lastStatus == 1 && !editMeeting" class="mt-3">
                    <div class="card" style="display: flow-root; padding: 5px" data-toggle="collapse" href="#collapseDocumentation" role="button" aria-expanded="false" aria-controls="collapseDocumentation">
                    <div class="float-left"> Visit Documentation </div>
                    <div class="float-right"><i class="fas fa-chevron-circle-down"></i></div>
                    </div>
                    <div class="collapse" id="collapseDocumentation" style="background-color: #E9ECEF; padding: 5px; border-radius: 5px;">
                        <div v-for="(data, index) in editVisitDocumentation" :key="index">
                            <div v-if="data.fileUrl != ''">
                                <a class="link-biru" :href="data.fileUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                            </div>
                        </div>
                    </div>
                </div>
                <table class="table table-sm table-bordered table-striped table-responsive-sm mt-3">
                    <thead>
                        <tr>
                            <th>Attemp</th>
                            <th>Schedule Date</th>
                            <th>Action By</th>
                            <th>Place</th>
                            <th>Note</th>
                            <th>Result</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loadingTable">
                            <td colspan="6" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                        </tr>
                        <tr v-else-if="dataMeeting == '' && !loadingTable">
                            <td colspan="6" class="text-center">Data not available</td>
                        </tr>
                        <tr v-else v-for="(data,index) in dataMeeting" :key="index">
                            <td>{{ index+1 }}</td>
                            <td>{{ data.scheduleDate }}</td>
                            <td>{{ data.actionBy }}</td>
                            <td>{{ data.place }}</td>
                            <td>{{ data.note }}</td>
                            <td>{{ data.result }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" v-if="(lastStatus != 1 && lastStatus != 99 && companyStatus != 99) || (lastStatus == 1 && editMeeting)">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="submitMeeting" v-if="!loadingButtonSave && lastStatus != 1 && lastStatus != 99 && companyStatus != 99 && companyStatus == 2 && meetingStatus != 1">Save</button>
              <button type="button" class="btn btn-primary btn-sm" @click="submitMeeting" v-if="!loadingButtonSave && lastStatus == null">Save</button>

              <button type="button" class="btn btn-primary btn-sm" @click="submitMeeting" v-if="(!loadingButtonSave && lastStatus != 1 && lastStatus != 99 && companyStatus == 2 && lastStatus != null && meetingStatus != 2 && meetingStatus != 99 && meetingStatus != '') || (!loadingButtonSave && lastStatus == 1 && editMeeting)">Save Draft</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="(loadingButtonSave && lastStatus != 1 && lastStatus != 99 && companyStatus != 99 && companyStatus == 2 && lastStatus != null && meetingStatus != 2 && meetingStatus != 99 && meetingStatus != '') || (loadingButtonSave && lastStatus == 1 && editMeeting)"><img src="~@/assets/images/2.gif" style="height: 18px;">Save Draft</button>

              <button type="button" class="btn btn-success btn-sm" @click="submitMeeting('send')" v-if="(!loadingButtonSaveSend && lastStatus != 1 && lastStatus != 99 && lastStatus != null && meetingStatus != 2 && meetingStatus != 99 && meetingStatus != '') || (!loadingButtonSaveSend && lastStatus == 1 && editMeeting)">Save & Send</button>
              <button type="button" class="btn btn-success btn-sm" disabled v-else-if="(loadingButtonSaveSend && lastStatus != 1 && lastStatus != 99 && companyStatus != 99 && lastStatus != null && meetingStatus != 2 && meetingStatus != 99 && meetingStatus != '') || (loadingButtonSaveSend && lastStatus == 1 && editMeeting)"><img src="~@/assets/images/2.gif" style="height: 18px;">Save & Send</button>

              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonSave && lastStatus != 1 && lastStatus != 99 && companyStatus != 99 && companyStatus == 2 && meetingStatus != 1"><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonSave && lastStatus == null"><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
              <button type="button" class="btn btn-primary btn-sm" v-else-if="lastStatus == 1 && !editMeeting" @click="editMeetingData">Edit</button>
            </div>
          </div>
        </div>
    </div>
    <!-- endModal -->
    <!-- Modal Verify-->
      <div class="modal fade" id="modalUploadLegalDocument" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Upload Legal Documents</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <div class="one-line">
                  <div class="ol-label">NPWP/SKT</div>
                  <div class="ol-titik2">:</div>
                  <div class="ol-value">
                      <input type="file" id="npwpInput" name="npwpSkt" @change="onFileDocPicked($event,'npwp')">
                  </div>
              </div>
              <div class="one-line" v-if="getNPWPName != null && getNPWPName != ''">
                  <div class="ol-label"></div>
                  <div class="ol-titik2"></div>
                  <div class="ol-value">
                      <i class="fa fa-check-circle" aria-hidden="true" style="color:green"></i>
                      <a class="link-biru" :href="NPWPUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                  </div>
              </div>
              <div class="one-line" v-if="NPWPFileName != ''">
                  <div class="ol-label">NPWP Number</div>
                  <div class="ol-titik2">:</div>
                  <div class="ol-value">
                      <input type="text" class="form-control form-control-sm" name="npwpNumber" v-model="inputNPWP">
                  </div>
              </div>
              <div class="one-line">
                  <div class="ol-label">Akta</div>
                  <div class="ol-titik2">:</div>
                  <div class="ol-value">
                      <input type="file" id="aktaInput" name="Akta" @change="onFileDocPicked($event,'akta')">
                  </div>
              </div>
              <div class="one-line" v-if="getAktaName != null && getAktaName != ''">
                  <div class="ol-label"></div>
                  <div class="ol-titik2"></div>
                  <div class="ol-value">
                        <i class="fa fa-check-circle" aria-hidden="true" style="color:green"></i>
                        <a class="link-biru" :href="aktaUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                  </div>
              </div>
              <div class="one-line" v-if="aktaFileName != ''">
                  <div class="ol-label">Address</div>
                  <div class="ol-titik2">:</div>
                  <div class="ol-value">
                      <input type="text" class="form-control form-control-sm" name="address" v-model="inputAddress">
                  </div>
              </div>
              <div class="one-line">
                  <div class="ol-label">SIUP</div>
                  <div class="ol-titik2">:</div>
                  <div class="ol-value">
                      <input type="file" id="siupInput" name="siup" @change="onFileDocPicked($event,'siup')">
                  </div>
              </div>
              <div class="one-line" v-if="getSiupName != null && getSiupName != ''">
                  <div class="ol-label"></div>
                  <div class="ol-titik2"></div>
                  <div class="ol-value">
                        <i class="fa fa-check-circle" aria-hidden="true" style="color:green"></i>
                        <a class="link-biru" :href="siupUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                  </div>
              </div>
              <div class="one-line">
                  <div class="ol-label">KTP PIC/Director</div>
                  <div class="ol-titik2">:</div>
                  <div class="ol-value">
                      <input type="file" id="ktpInput" name="ktp" @change="onFileDocPicked($event,'ktp')">
                  </div>
              </div>
              <div class="one-line" v-if="getKtpName != null && getKtpName != ''">
                  <div class="ol-label"></div>
                  <div class="ol-titik2"></div>
                  <div class="ol-value">
                        <i class="fa fa-check-circle" aria-hidden="true" style="color:green"></i>
                        <a class="link-biru" :href="companyKTPUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                  </div>
              </div>
              <div class="one-line" v-if="KTPFileName != ''">
                  <div class="ol-label">KTP Number</div>
                  <div class="ol-titik2">:</div>
                  <div class="ol-value">
                      <input type="text" class="form-control form-control-sm" @keypress="isNumber($event)" name="ktpNumber" v-model="inputKTP">
                  </div>
              </div>
              <div class="one-line">
                  <div class="ol-label">SK Menkumham</div>
                  <div class="ol-titik2">:</div>
                  <div class="ol-value">
                      <input type="file" id="skInput" name="sk" @change="onFileDocPicked($event,'sk')">
                  </div>
              </div>
              <div class="one-line" v-if="getSKName != null && getSKName != ''">
                  <div class="ol-label"></div>
                  <div class="ol-titik2"></div>
                  <div class="ol-value">
                        <i class="fa fa-check-circle" aria-hidden="true" style="color:green"></i>
                        <a class="link-biru" :href="SKUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                  </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="uploadLegalDoc()" v-if="loadingButtonProcess == false">Yes, Sure</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Yes, Sure</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- Modal Agreement-->
      <div class="modal fade" id="modalSendAgreement" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Send Agreement</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <p>Are you sure to send agreement to {{ companyName }}?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="sendAgreement('send')" v-if="loadingButtonProcess == false">Yes, Sure</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Yes, Sure</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- Modal process agreement -->
      <div class="modal fade" id="modalProcessAgreement" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Process Agreement</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="one-line">
                    <label class="ol-label"> Option</label>
                    <label class="ol-titik2">:</label>
                    <select class="form-control form-control-sm" v-model="chooseAgreementStatus">
                        <option value="1">Agreement Accepted</option>
                        <option value="2">Resend Agreement</option>
                    </select>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="sendAgreement('process')" v-if="loadingButtonProcess == false">Yes, Sure</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Yes, Sure</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- Modal process agreement -->
      <div class="modal fade" id="modalUpdateStatus" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Update Status</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="one-line">
                    <label class="ol-label"> Option</label>
                    <label class="ol-titik2">:</label>
                    <select class="form-control form-control-sm" v-model="chooseCompanyStatus">
                        <option value="8">Verified</option>
                        <option value="99">Rejected</option>
                    </select>
                </div>
                <div class="one-line" v-if="chooseCompanyStatus == 99">
                    <label class="ol-label"> Reason</label>
                    <label class="ol-titik2">:</label>
                    <multiselect v-model="rejectLesseeReason" :options="reasonSelect" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Reason" style="height: 5px;"></multiselect>
                </div>
                <div class="one-line" v-if="rejectLesseeReason == 'Other'">
                    <label class="ol-label">New Reason</label>
                    <label class="ol-titik2">:</label>
                    <input type="text" name="reason" v-model="newReason" class="form-control form-control-sm">
                </div>
                <div class="one-line" v-if="chooseCompanyStatus == 99">
                    <label class="ol-label">Note</label>
                    <label class="ol-titik2">:</label>
                    <textarea class="form-control" style="height: 90px; resize: none" v-model="rejectNotes"></textarea>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="updateStatus" v-if="loadingButtonProcess == false">Yes, Sure</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Yes, Sure</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
      <div class="modal fade" id="modalEditAsaniPIC" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-md">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Change ASANI PIC</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="one-line">
                    <label class="ol-label"> Name </label>
                    <label class="ol-titik2">:</label>
                    <multiselect v-model="employeeAsani" :options="employeeSelect" label="employeeName" track-by="employeeName" :allow-empty="false" deselect-label="Can't remove this value" placeholder="Select Employee"></multiselect>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" v-if="companyStatus != 99">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="submitChangePicAsani" v-if="!loadingButtonSave && companyStatus != 99">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonSave && companyStatus != 99"><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
            </div>
          </div>
        </div>
    </div>
    <div class="modal fade" id="modalEditSalesStatus" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-md">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Change Sales Status</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="one-line">
                    <label class="ol-label"> Status </label>
                    <label class="ol-titik2">:</label>
                    <multiselect v-model="chooseSalesStatus" :options="salesStatusSelect" label="statusName" track-by="statusName" :allow-empty="false" deselect-label="Can't remove this value" placeholder="Select Status"></multiselect>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" v-if="companyStatus != 99">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="submitChangeSalesStatus" v-if="!loadingButtonSave && companyStatus != 99">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonSave && companyStatus != 99"><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
            </div>
          </div>
        </div>
    </div>
    <ModalEditCompanyInfoLessee 
        :lesseeData="lesseeDetailData" 
        :triggerOpen="triggerOpenCompanyInfo" 
        @success-edit-company="handleSuccessEditCompany" 
    />
    <ModalChangeNPWPDoc
        :triggerOpen="triggerOpenChangeNPWPDoc"
        :companyId="companyId"
        :lesseeData="lesseeDetailData"
        :newCompany="newCompany !== null? newCompany : false"
        @success-change-document-npwp="handleSuccessChangeDocumentNPWP"
    />
    <ModalChangeNPWPDocStatus
        :NPWPStatus="NPWPStatus? NPWPStatus : 0"
        :lesseeData="lesseeDetailData"
        :newCompany="newCompany !== null? newCompany : false"
        :companyId="companyId"
        @success-change-document-npwp-status="handleSuccessChangeDocumentNPWPStatus"
    />
  </div>
</template>

<script>
  import SideBar from '../SideBar'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import DatePicker from 'vue2-datepicker';
  // import 'vue2-datepicker/index.css';
  import ModalEditCompanyInfoLessee from './Component/ModalEditCompanyInfoLessee.vue';
  import ModalChangeNPWPDoc from './Component/ModalChangeNPWPDoc.vue';
  import ModalChangeNPWPDocStatus from './Component/ModalChangeNPWPDocStatus.vue';

  export default {
    name: 'OrderDetailPage',
    components: {
      SideBar, 
      Multiselect,
      DatePicker,
      ModalChangeNPWPDoc,
      ModalEditCompanyInfoLessee,
      ModalChangeNPWPDocStatus
    },
    data() {
      return {
        spaceRegex: /[\u00A0\uFEFF\u202F]/g,
        chooseSalesStatus:{
            status:'',
            statusName:''
        },
        salesStatusSelect:[
        {
            status:0,
            statusName:'On Hold'
        },
        {
            status:1,
            statusName:'On Prospect'
        },
        {
            status:2,
            statusName:'On Going'
        },],
        employeeAsani:{
            id:'',
            employeeName:''
        },
        jwt: localStorage.getItem('jwt'),
        employeeSelect:[],
        rejectCompanyReason:'',
        rejectReason:'',
        NPWPFileName:"",
        NPWPFile:"",
        NPWPUrl:"",
        NPWPBase64:"",
        SIUPFileName:"",
        SIUPFile:"",
        SIUPUrl:"",
        SIUPBase64:"",
        aktaFileName:"",
        aktaFile:"",
        aktaUrl:"",
        aktaBase64:"",
        KTPFileName:"",
        KTPFile:"",
        KTPUrl:"",
        KTPBase64:"",
        SKFileName:"",
        SKFile:"",
        SKUrl:"",
        SKBase64:"",
        getNPWPName:'',
        getSiupName:'',
        getAktaName:'',
        getKtpName:'',
        getSKName:'',
        meetingStatus:'',
        meetingSchedule:'',
        contactingDate:'',
        meetingPlace:'',
        noteMeeting:'',
        reasonMeeting:'',
        dataMeeting:[],
        lastStatus:'',
        dataContacting:[],
        channel:'',
        noteContacting:'',
        lesseeAdmin:[],
        newCompany:null,
        dataOrder: [],
        columns: ['companyName', 'orderID'],
        totalPage:0,
        totalData:0,
        currentPage:1,
        viewDashboard: false,
        viewOrder: false,
        viewReturn: false,
        viewProduct: false,
        viewPairing: false,
        viewReconcile: false,
        viewResolution: false,
        viewLessor: false,
        viewLessee: false,
        viewLesseeVerification: false,
        viewEmployee: false,
        editOrder: false,
        editReturn: false,
        editProduct: false,
        editPairing: false,
        editReconcile: false,
        editResolution: false,
        editLessor: false,
        editLessee: false,
        editEmployee: false,
        loadingButtonSave:false,
        loadingButtonSaveSend:false,
        orderId:"",
        companyName:"",
        companyAddress:"",
        companyPhone:"",
        companyFax:"",
        picId:"",
        userName:"",
        companyKtpPassportNumber:"",
        citizenship:"",
        userPhone:"",
        userEmail:"",
        userPosition:"",
        userDivision:"",
        editUserName:"",
        editUserKTP:"",
        editCompanyNpwp:"",
        editUserPhone:"",
        editUserEmail:"",
        editUserPosition:"",
        editUserDivision:"",
        statusOrder:"",
        KTPNumber:"",
        uploadKTPNumber:"",
        noteChangeDocument:"",
        companyLogoUrl:"",
        docStatus:0,
        companyKTPStatus:0,
        companyKTPUrl:"",
        NPWPStatus:null,
        siupStatus:null,
        aktaStatus:null,
        aktaPerubahanStatus:null,
        SKStatus:null,
        SKPerubahanStatus:null,
        NPWPUrl:"",
        siupUrl:"",
        aktaUrl:"",
        purchaseUrl:"",
        admin:"",
        adminId:"",
        inputs:[],
        assignDeposit:0,
        productOrder:[],
        Deposit:0,
        docPilih:"",
        loadingButtonProcess:false,
        loadingButtonProcessNo:false,
        loadingTable:true,
        loadingTableAssign:false,
        loadingStatusKTP:true,
        loadingStatusNPWP:true,
        loadingStatusSiup:true,
        loadingStatusAkta:true,
        loadingStatusAktaPerubahan:true,
        loadingStatusSK:true,
        loadingStatusSKPerubahan:true,
        loadingTableDoc:false,
        loadingTableEdit:false,
        lesseeId:"",
        historyDocData:[],
        docFile:'',
        docFileName:'',
        docUrl:'',
        docBase64:'',
        productRenting:0,
        province:[],
        kabkot:[],
        kecamatan:[],
        editCompanyFax:'',
        editCompanyPhone:'',
        editSource:'',
        editCompanyAddress:'',
        editAktaAddress:'',
        editCompanyName:'',
        editProvince:'',
        editKabKot:'',
        editKecamatan:'',
        editKelurahan:'',
        editZip:'',
        apiProvince:'',
        apiKabKot:'',
        apiKecamatan:'',
        apiDataKecamatan:[],
        apiDataKabkot:[],
        companyProvince:'',
        companyDistrict:'',
        companyCity:'',
        companyVillage:'',
        companyZip:'',
        companyNPWP:"",
        aktaAddress:"",
        source:"",
        logCompany:[],
        logLessee:[],
        sourceSelect:[],
        newSource:'',
        docApprove:0,
        companyStatus:0,
        getNPWPName:'',
        getSiupName:'',
        getAktaName:'',
        getKtpName:'',
        getSKName:'',
        agreementCount:null,
        agreementStatus:'',
        chooseAgreementStatus:'1',
        chooseCompanyStatus:'8',
        NpwpDocInput:'',
        aktaAdressInput:'',
        rejectLesseeReason:'',
        reasonSelect:[],
        newReason:'',
        rejectNotes:'',
        inputAsaniAttend:[''],
        inputClientAttend:[''],
        employeeName:[''],
        employeePosition:[''],
        clientName:[''],
        clientPosition:[''],
        meetingResult:'',
        listToDo:'',
        meetingAddress:'',
        meetingAgenda:'',
        companySince:'',
        totalEmployeeClient:'',
        industryType:'',
        editInputAsaniAttend:[''],
        editInputClientAttend:[''],
        editEmployeeName:[''],
        editEmployeePosition:[''],
        editClientName:[''],
        editClientPosition:[''],
        editMeetingResult:'',
        editListToDo:'',
        editMeetingAddress:'',
        editMeetingAgenda:'',
        editCompanySince:'',
        editTotalEmployeeClient:'',
        editIndustryType:'',
        editMeeting:false,
        visitDocumentation:[
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''}
        ],
        editVisitDocumentation:[
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''}
        ],
        asaniEmployeeName:'',
        asaniPicPhone:'',
        historyNpwp:[],
        historyAkta:[],
        historyAktaPerubahan: [],
        historyKtp:[],
        historySiup:[],
        historySk:[],
        historySkPerubahan: [],
        salesStatus:'',
        loadingTableNpwp:true,
        loadingTableAkta:true,
        loadingTableSiup:true,
        loadingTableSk:true,
        loadingTableKtp:true,
        triggerOpenChangeNPWPDoc: false,
        lesseeDetailData: {},
        triggerOpenCompanyInfo: false,
        companyNPWP16:'',
        companyNPWP22:'',

        companyNameNPWP:'',
      }
    },
    methods: {
        editMeetingData(){
            this.editMeeting = true
        },
        handleSuccessEditCompany({w,x,y}) {
            w.forEach((logType) => {
                this.sendLog(logType, x, y)
            })
            this.getData()
        },
        toggleEditCompanyInfo() {
            this.triggerOpenCompanyInfo = !this.triggerOpenCompanyInfo;
        },
        toggleOpenChangeNPWPDoc() {
            this.triggerOpenChangeNPWPDoc = !this.triggerOpenChangeNPWPDoc;
        },
        handleSuccessChangeDocumentNPWP() {
            this.sendLog(9,this.companyId,'company')
            this.getData()
        },
        handleSuccessChangeDocumentNPWPStatus() {
          this.getData()  
        },
        cekAttendError: function(x){
            let error = 0
            if (x=='Asani') {
                for (var i = 0; i < this.inputAsaniAttend.length; i++) {
                    if(this.employeeName[i] == '' || this.employeePosition[i] == ''){
                        error = error+1
                    }
                }
            }else{
                for (var i = 0; i < this.inputClientAttend.length; i++) {
                    if(this.clientName[i] == '' || this.clientPosition[i] == ''){
                        error = error+1
                    }
                }
            }
            return error
        },
        addAttend(x){
            let error = 0
            if (x=='Asani') {
                if (this.cekAttendError('Asani') > 0) {
                    swal("Sorry", "Please fill the Asani Attendant" , "error", {
                      button: "Close",
                    })
                }else{
                    this.inputAsaniAttend.push([''])
                    this.employeeName.push('')
                    this.employeePosition.push('')  
                }
            }else{
                if (this.cekAttendError('Client') > 0) {
                    swal("Sorry", "Please fill the Client Attendant" , "error", {
                      button: "Close",
                    })
                }else{
                    this.inputClientAttend.push([''])
                    this.clientName.push('')
                    this.clientPosition.push('')
                }
            }
        },
        removeRow(name,index) {
            if (name=='Asani') {
                this.inputAsaniAttend.splice(index,1)
                this.employeeName.splice(index,1)
                this.employeePosition.splice(index,1)
            }else{
                this.inputClientAttend.splice(index,1)
                this.clientName.splice(index,1)
                this.clientPosition.splice(index,1)
            }
        },
        dateToString: function(date,second){
            var today = new Date(date);
            var month = today.getMonth()+1
            if (month < 10) {
                month = '0'+month
            }
            var dateDay = today.getDate()
            if (dateDay < 10) {
                dateDay = '0'+dateDay
            }
            var hours = today.getHours()
            if (hours < 10) {
                hours = '0'+hours
            }
            var minutes = today.getMinutes()
            if (minutes < 10) {
                minutes = '0'+minutes
            }
            var second = today.getSeconds()
            if (second < 10) {
                second = '0'+second
            }
            var date = today.getFullYear()+'-'+month+'-'+dateDay;
            if (second) {
                var time = hours + ":" + minutes+":"+second;    
            }else{
                var time = hours + ":" + minutes;
            }
            
            var dateTime = date+'T'+time;
            return dateTime
        },
        updateDocStatus(x){
            if (x == 'KTP') {
                if ((this.KTPNumber == '' || this.KTPNumber == null) && this.docStatus != 2) {
                    swal("Sorry", "Please fill the KTP Number" , "error", {
                      button: "Close",
                    })
                }else if (this.KTPNumber != null && this.citizenship === 'wni' && this.KTPNumber.length != 16 && this.docStatus != 2) {
                    swal("Sorry", "KTP Number must be 16 Digit" , "error", {
                      button: "Close",
                    })
                }else if (this.docStatus == 0) {
                    swal("Sorry", "Please choose status" , "error", {
                      button: "Close",
                    })
                }else if(this.docStatus == 2){
                    if (this.rejectReason == '') {
                        swal("Sorry", "Please fill reason" , "error", {
                          button: "Close",
                        })
                    }else{
                        this.loadingButtonProcess = true
                        this.loadingStatusKTP = true
                        this.submitDocStatus(x)
                    }
                }else{
                    this.loadingButtonProcess = true
                    this.loadingStatusKTP = true
                    this.submitDocStatus(x)  
                }
            }else if (x == 'Akta') {
                if ((this.aktaAdressInput == '' || this.aktaAdressInput == null) && this.docStatus != 2) {
                    swal("Sorry", "Please fill akta address" , "error", {
                      button: "Close",
                    })
                }else if (this.docStatus == 0) {
                    swal("Sorry", "Please choose status" , "error", {
                      button: "Close",
                    })
                }else if(this.docStatus == 2){
                    if (this.rejectReason == '') {
                        swal("Sorry", "Please fill reason" , "error", {
                          button: "Close",
                        })
                    }else{
                        this.loadingButtonProcess = true
                        this.loadingStatusAkta = true
                        this.submitDocStatus(x)
                    }
                }else{
                    this.loadingButtonProcess = true
                    this.loadingStatusAkta = true
                    this.submitDocStatus(x)  
                }
            } 
            else if (x == 'Akta Perubahan') {
                if ((this.aktaAdressInput == '' || this.aktaAdressInput == null) && this.docStatus != 2) {
                    swal("Sorry", "Please fill akta address" , "error", {
                      button: "Close",
                    })
                }
                if (this.docStatus == 0) {
                    swal("Sorry", "Please choose status" , "error", {
                      button: "Close",
                    })
                }else if(this.docStatus == 2){
                    if (this.rejectReason == '') {
                        swal("Sorry", "Please fill reason" , "error", {
                          button: "Close",
                        })
                    }else{
                        this.loadingButtonProcess = true
                        this.loadingStatusAkta = true
                        this.submitDocStatus(x)
                    }
                }else{
                    this.loadingButtonProcess = true
                    this.loadingStatusAkta = true
                    this.submitDocStatus(x)  
                }
            } else if (x == 'NPWP/SKT') {
                if ((this.NpwpDocInput == '' || this.NpwpDocInput == null) && this.docStatus != 2) {
                    swal("Sorry", "Please fill NPWP Number" , "error", {
                      button: "Close",
                    })
                } else if (this.NpwpDocInput && this.NpwpDocInput.toString().length > 20) {
                    swal("Sorry", "NPWP maximum length is 20" , "error", {
                        button: "Close",
                    })
                }else if (this.docStatus == 0) {
                    swal("Sorry", "Please choose status" , "error", {
                      button: "Close",
                    })
                }else if(this.docStatus == 2){
                    if (this.rejectReason == '') {
                        swal("Sorry", "Please fill reason" , "error", {
                          button: "Close",
                        })
                    }else{
                        this.loadingButtonProcess = true
                        this.loadingStatusNPWP = true
                        this.submitDocStatus(x)
                    }
                }else{
                    this.loadingButtonProcess = true
                    this.loadingStatusNPWP = true
                    this.submitDocStatus(x)  
                }
            }else if (x == 'SIUP') {
                if (this.docStatus == 0) {
                    swal("Sorry", "Please choose status" , "error", {
                      button: "Close",
                    })
                }else if(this.docStatus == 2){
                    if (this.rejectReason == '') {
                        swal("Sorry", "Please fill reason" , "error", {
                          button: "Close",
                        })
                    }else{
                        if (x == 'NPWP/SKT') {
                            this.loadingStatusNPWP = true   
                        }else if (x == 'Akta') {
                            this.loadingStatusAkta = true
                        }else if (x == 'SIUP') {
                            this.loadingStatusSiup = true
                        }else if (x == 'Purchase Order') {
                            this.loadingStatusPurchase = true
                        }
                        this.loadingButtonProcess = true
                        this.submitDocStatus(x) 
                    }
                }else{
                    if (x == 'NPWP/SKT') {
                        this.loadingStatusNPWP = true   
                    }else if (x == 'Akta') {
                        this.loadingStatusAkta = true
                    }else if (x == 'SIUP') {
                        this.loadingStatusSiup = true
                    }else if (x == 'Purchase Order') {
                        this.loadingStatusPurchase = true
                    }
                    this.loadingButtonProcess = true
                    this.submitDocStatus(x)   
                }
            }else if (x == 'SK Menkumham') {
                if (this.docStatus == 0) {
                    swal("Sorry", "Please choose status" , "error", {
                      button: "Close",
                    })
                }else if(this.docStatus == 2){
                    if (this.rejectReason == '') {
                        swal("Sorry", "Please fill reason" , "error", {
                          button: "Close",
                        })
                    }else{
                        if (x == 'NPWP/SKT') {
                            this.loadingStatusNPWP = true   
                        }else if (x == 'Akta') {
                            this.loadingStatusAkta = true
                        }else if (x == 'SIUP') {
                            this.loadingStatusSiup = true
                        }else if (x == 'Purchase Order') {
                            this.loadingStatusPurchase = true
                        }
                        this.loadingButtonProcess = true
                        this.submitDocStatus(x) 
                    }
                }else{
                    if (x == 'NPWP/SKT') {
                        this.loadingStatusNPWP = true   
                    }else if (x == 'Akta') {
                        this.loadingStatusAkta = true
                    }else if (x == 'SIUP') {
                        this.loadingStatusSiup = true
                    }else if (x == 'Purchase Order') {
                        this.loadingStatusPurchase = true
                    }
                    this.loadingButtonProcess = true
                    this.submitDocStatus(x)   
                }
            } else if (x == 'SK Menkumham Perubahan') {
                if (this.docStatus == 0) {
                    swal("Sorry", "Please choose status" , "error", {
                      button: "Close",
                    })
                }else if(this.docStatus == 2){
                    if (this.rejectReason == '') {
                        swal("Sorry", "Please fill reason" , "error", {
                          button: "Close",
                        })
                    }else{
                        if (x == 'NPWP/SKT') {
                            this.loadingStatusNPWP = true   
                        }else if (x == 'Akta') {
                            this.loadingStatusAkta = true
                        }else if (x == 'Akta Perubahan') {
                            this.loadingStatusAktaPerubahan = true
                        }else if (x == 'SIUP') {
                            this.loadingStatusSiup = true
                        }else if (x == 'Purchase Order') {
                            this.loadingStatusPurchase = true
                        }
                        this.loadingButtonProcess = true
                        this.submitDocStatus(x) 
                    }
                }else{
                    if (x == 'NPWP/SKT') {
                        this.loadingStatusNPWP = true   
                    }else if (x == 'Akta') {
                        this.loadingStatusAkta = true
                    }else if (x == 'Akta Perubahan') {
                        this.loadingStatusAktaPerubahan = true
                    }else if (x == 'SIUP') {
                        this.loadingStatusSiup = true
                    }else if (x == 'Purchase Order') {
                        this.loadingStatusPurchase = true
                    }
                    this.loadingButtonProcess = true
                    this.submitDocStatus(x)   
                }
            }
        },
        submitDocStatus(x){
            const {companyNPWP16, companyNPWP22} = this.lesseeDetailData.detailLessee[0]
            this.$http.post(process.env.UPDATE_COMPANY_DOC_STATUS,{
                  lesseeId: this.picId,
                  type: x === "KTP"? "KTP/Passport": x,
                  userKTPPassport: this.KTPNumber.replace(this.spaceRegex, ' '),
                  newStatus: this.docStatus,
                  adminId: this.adminId,
                  rejectReason: this.rejectReason.replace(this.spaceRegex, ' '),
                  npwpNumber:this.NpwpDocInput.replace(this.spaceRegex, ' '),
                  npwpNumber16: companyNPWP16,
                  npwpNumber22: companyNPWP22,
                  aktaAddress: this.aktaAdressInput.replace(this.spaceRegex, ' '),
                  newCompany : this.newCompany,
                  companyNameNPWP: this.companyNameNPWP.replace(this.spaceRegex, ' ')
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
            .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message , "error", {
                        button: "Close",
                    })
                }
                  if (response.data.status == 200) {
                    swal("Success", response.data.message , "success", {
                      button: "Close",
                    })
                  }
                  if (x == 'KTP') {
                    this.loadingStatusKTP = false
                  }else if (x == 'NPWP/SKT') {
                    this.loadingStatusNPWP = false
                  }else if (x == 'SIUP') {
                    this.loadingStatusSiup = false
                  }else if (x == 'Akta') {
                    this.loadingStatusAkta = false
                  }else if (x == 'Purchase Order') {
                    this.loadingStatusPurchase = false
                  }
                  $('#modalDocPending').modal('hide')
                  this.getData()
                  this.loadingButtonProcess = false
            })
            .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        updateStatus(){
            let reason = ''
            let newReason = ''
            if (this.chooseCompanyStatus == 99 && this.rejectLesseeReason == '') {
                swal("Sorry", 'Reason must be select' , "error", {
                    button: "Close",
                })
            }else if (this.chooseCompanyStatus == 99 && this.rejectLesseeReason == 'Other' && this.newReason == '') {
                swal("Sorry", 'New reason must be fill' , "error", {
                    button: "Close",
                })
            }else if (this.chooseCompanyStatus == 8) {
                this.loadingButton = true
                this.loadingButtonProcess = true
                this.$http.post(process.env.CEK_COMPANY_STATUS,{
                  companyId: this.companyId,
                  newCompany: this.newCompany
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }else{
                        if (response.data.data.companyStatus < 7 || response.data.data == null || response.data.data.companyStatus == null) {
                            swal("Sorry", 'You must follow step KYC lessee' , "error", {
                                button: "Ok",
                            })  
                            $('#modalUpdateStatus').modal('hide')
                            this.loadingButtonProcess = false
                        }else{
                            this.$http.post(process.env.UPDATE_COMPANY_STATUS,{
                                companyId: this.companyId,
                                companyStatus: this.chooseCompanyStatus,
                                reason: this.rejectReason.replace(this.spaceRegex, ' '),
                                newCompany: this.newCompany
                            },{
                              headers: {'Asani-Token':localStorage.getItem('jwt')}
                            })
                            .then(response => {
                              if (response.data.status == 200) {
                                swal("Success", response.data.message , "success", {
                                  button: "Ok",
                                })
                              }
                              if (response.data.status == 201) {
                                swal("Sorry", response.data.message , "error", {
                                  button: "Close",
                                })
                              }
                              if (response.data.status == 400) {
                                    swal("Sorry", response.data.message , "error", {
                                        button: "Close",
                                    })
                                }
                              $('#modalUpdateStatus').modal('hide')
                              this.getData()
                              this.loadingButtonProcess = false
                            })
                            .catch(error => {
                                swal("Sorry", error.response.data.message, "error", {
                                    button: "Ok",
                                }).then(v => {
                                    if(error.response.data.status == 401) {
                                        this.handleLogout()
                                    }
                                })
                            })
                        }
                    }
                    this.loadingButton = false
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }else if (this.chooseCompanyStatus == 99) {
                if (this.rejectLesseeReason == 'Other') {
                    newReason = this.newReason
                    reason = this.newReason+', '+this.rejectNotes
                }else{
                    if (this.rejectNotes != '') {
                        reason = this.rejectLesseeReason+', '+this.rejectNotes
                    }else{
                        reason = this.rejectLesseeReason
                    }
                    
                }
                this.loadingButtonProcess = true
                this.$http.post(process.env.UPDATE_COMPANY_STATUS,{
                    companyId: this.companyId,
                    companyStatus: this.chooseCompanyStatus,
                    reason: reason.replace(this.spaceRegex, ' '),
                    newCompany: this.newCompany,
                    newReason:newReason.replace(this.spaceRegex, ' ')
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                  if (response.data.status == 200) {
                    swal("Success", response.data.message , "success", {
                      button: "Ok",
                    })
                  }
                  if (response.data.status == 201) {
                    swal("Sorry", response.data.message , "error", {
                      button: "Close",
                    })
                  }
                  if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Close",
                        })
                    }
                  $('#modalUpdateStatus').modal('hide')
                  this.getData()
                  this.loadingButtonProcess = false
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }
        },
        sendAgreement(x){
            this.loadingButtonProcess = true
            this.$http.post(process.env.SEND_COMPANY_AGREEMENT,{
                companyId: this.companyId,
                agreement: x,
                agreementStatus: this.chooseAgreementStatus,
                newCompany:this.newCompany
            },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
              if (response.data.status == 200) {
                swal("Success", response.data.message , "success", {
                  button: "Ok",
                })
                if (x == 'send') {
                    // this.sendLog(14,'sendAgreement')
                }else{
                    if (this.chooseAgreementStatus == 1) {
                        // this.sendLog(16,'ProcessAgreement')
                    }else{
                        // this.sendLog(14,'ProcessAgreement')    
                    }
                }
              }
              if (response.data.status == 201) {
                swal("Sorry", response.data.message , "error", {
                  button: "Close",
                })
              }
              if (response.data.status == 400) {
                    swal("Sorry", response.data.message , "error", {
                        button: "Close",
                    })
                }
              $('#modalSendAgreement').modal('hide')
              $('#modalProcessAgreement').modal('hide')
              this.getData()
              this.loadingButtonProcess = false
            })
            .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        onFileDocPicked(e,x) {
            const files = e.target.files
            if (x == 'npwp') {
                if (files[0] !== undefined) {
                    this.NPWPFileName = files[0].name
                    if (this.NPWPFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.NPWPUrl = fr.result
                        this.NPWPFile = files[0] // this is an image file that can be sent to server...
                        this.NPWPBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.NPWPFileName = ''
                    this.NPWPFile = ''
                    this.NPWPUrl = ''
                }
            }else if (x == 'akta') {
                if (files[0] !== undefined) {
                    this.aktaFileName = files[0].name
                    if (this.aktaFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.aktaUrl = fr.result
                        this.aktaFile = files[0] // this is an image file that can be sent to server...
                        this.aktaBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.aktaFileName = ''
                    this.aktaFile = ''
                    this.aktaUrl = ''
                }
            }else if (x == 'siup') {
                if (files[0] !== undefined) {
                    this.SIUPFileName = files[0].name
                    if (this.SIUPFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.SIUPUrl = fr.result
                        this.SIUPFile = files[0] // this is an image file that can be sent to server...
                        this.SIUPBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.SIUPFileName = ''
                    this.SIUPFile = ''
                    this.SIUPUrl = ''
                }
            }else if (x == 'ktp') {
                if (files[0] !== undefined) {
                    this.KTPFileName = files[0].name
                    if (this.KTPFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.KTPUrl = fr.result
                        this.KTPFile = files[0] // this is an image file that can be sent to server...
                        this.KTPBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.KTPFileName = ''
                    this.KTPFile = ''
                    this.KTPUrl = ''
                }
            }else if (x == 'purchase') {
                if (files[0] !== undefined) {
                    this.purchaseFileName = files[0].name
                    if (this.purchaseFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.purchaseOrderUrl = fr.result
                        this.purchaseFile = files[0] // this is an image file that can be sent to server...
                        this.purchaseBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.purchaseFileName = ''
                    this.purchaseFile = ''
                    this.purchaseOrderUrl = ''
                }
            }else if (x == 'sk') {
                if (files[0] !== undefined) {
                    this.SKFileName = files[0].name
                    if (this.SKFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.SKUrl = fr.result
                        this.SKFile = files[0] // this is an image file that can be sent to server...
                        this.SKBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.SKFileName = ''
                    this.SKFile = ''
                    this.SKUrl = ''
                }
            }else{
                if (files[0] !== undefined) {
                    this.visitDocumentation[x].fileName = files[0].name
                    if (this.visitDocumentation[x].fileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.visitDocumentation[x].fileUrl = fr.result
                        this.visitDocumentation[x].file = files[0] // this is an image file that can be sent to server...
                        this.visitDocumentation[x].fileBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.visitDocumentation[x].fileName = ''
                    this.visitDocumentation[x].file = ''
                    this.visitDocumentation[x].fileUrl = ''
                    this.visitDocumentation[x].fileBase64 = ''
                }
            }
        },
        cekUploadLegal: function(){
            var error = 0
            if (this.NPWPFileName == '' && this.aktaFileName == '' && this.SIUPFileName == '' && this.KTPFileName == '' && this.SKFileName == '') {
                swal("Sorry", "minimal 1 file must be upload" , "error", {
                  button: "Close",
                })
                error = error+1
                return error
            }else if (this.NPWPFileName != '') {
                if (this.inputNPWP == '' || this.inputNPWP == null) {
                    swal("Sorry", "NPWP Number must be fill" , "error", {
                      button: "Close",
                    })
                    error = error+1
                    return error
                }else if(this.inputNPWP && this.inputNPWP.toString().length > 20) {
                    swal("Sorry", "NPWP maximum length is 20" , "error", {
                        button: "close",
                    })
                    error = error+1
                    return error
                }else if (this.aktaFileName != '') {
                    if (this.inputAddress == '' || this.inputAddress == null) {
                        swal("Sorry", "Address must be fill" , "error", {
                          button: "Close",
                        })
                        error = error+1
                        return error
                    }else if (this.KTPFileName != '') {
                        if (this.inputKTP == '' || this.inputKTP == null) {
                            swal("Sorry", "KTP must be fill" , "error", {
                              button: "Close",
                            })
                            error = error+1
                            return error
                        }
                    }
                }else if (this.KTPFileName != '') {
                    if (this.inputKTP == '' || this.inputKTP == null) {
                        swal("Sorry", "KTP must be fill" , "error", {
                          button: "Close",
                        })
                        error = error+1
                        return error
                    }
                }
            }else if (this.aktaFileName != '') {
                if (this.inputAddress == '' || this.inputAddress == null) {
                    swal("Sorry", "Address must be fill" , "error", {
                      button: "Close",
                    })
                    error = error+1
                    return error
                }else if (this.KTPFileName != '') {
                    if (this.inputKTP == '' || this.inputKTP == null) {
                        swal("Sorry", "KTP must be fill" , "error", {
                          button: "Close",
                        })
                        error = error+1
                        return error
                    }
                }
            }else if (this.KTPFileName != '') {
                if (this.inputKTP == '' || this.inputKTP == null) {
                    swal("Sorry", "KTP must be fill" , "error", {
                      button: "Close",
                    })
                    error = error+1
                    return error
                }
            }
            return error
        },
        uploadLegalDoc(){
            if (this.cekUploadLegal() == 0)
            {
                this.loadingButtonProcess = true
                this.$http.post(process.env.ADD_LEGAL_DOC,{
                  adminId: this.adminId,
                  NPWPFileName: this.NPWPFileName.replace(this.spaceRegex, ' '),
                  NPWPBase64: this.NPWPBase64,
                  npwpNumber: this.inputNPWP.replace(this.spaceRegex, ' '),
                  aktaFileName: this.aktaFileName.replace(this.spaceRegex, ' '),
                  aktaBase64: this.aktaBase64,
                  companyAddress: this.inputAddress.replace(this.spaceRegex, ' '),
                  SIUPFileName: this.SIUPFileName.replace(this.spaceRegex, ' '),
                  SIUPBase64: this.SIUPBase64,
                  KTPFileName: this.KTPFileName.replace(this.spaceRegex, ' '),
                  KTPBase64: this.KTPBase64,
                  ktpNumber: this.inputKTP.replace(this.spaceRegex, ' '),
                  companyId: this.companyId,
                  SKFileName: this.SKFileName.replace(this.spaceRegex, ' '),
                  SKBase64: this.SKBase64,
                  picId: this.picId,
                  newCompany:this.newCompany,
                  companyNameNPWP: this.companyNameNPWP.replace(this.spaceRegex, ' ')
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                  if (response.data.status == 200) {
                    swal("Success", response.data.message , "success", {
                      button: "Ok",
                    })
                    if (this.NPWPBase64 != '') {
                        this.sendLog(9,this.companyId,'company')
                    }
                    if (this.aktaBase64 != '') {
                        this.sendLog(10,this.companyId,'company')
                    }
                    if (this.SIUPBase64 != '') {
                        this.sendLog(11,this.companyId,'company')
                    }
                    if (this.KTPBase64 != '') {
                        this.sendLog(12,this.companyId,'company')
                    }
                    if (this.SKBase64 != '') {
                        // this.sendLog(12,'legalDoc')
                    }
                  }
                  if (response.data.status == 201) {
                    swal("Sorry", response.data.message , "error", {
                      button: "Close",
                    })
                  }
                  if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Close",
                        })
                    }
                  $('#modalUploadLegalDocument').modal('hide')
                  document.getElementById("npwpInput").value = "";
                  document.getElementById("ktpInput").value = "";
                  document.getElementById("siupInput").value = "";
                  document.getElementById("skInput").value = "";
                  document.getElementById("aktaInput").value = "";
                  this.NPWPFileName =''
                  this.NPWPBase64 =''
                  this.aktaFileName =''
                  this.aktaBase64 =''
                  this.SIUPFileName =''
                  this.SIUPBase64 =''
                  this.KTPFileName =''
                  this.KTPBase64 =''
                  this.SKFileName =''
                  this.SKBase64 =''
                  this.getData()
                  this.loadingButtonProcess = false
                  this.loadingButtonProcessNo = false
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                        this.handleLogout()
                        }
                    })
                })
            }
        },
        submitMeeting(x){
            if (this.lastStatus != null) {
                if (this.lastStatus != 1) {
                    if (this.meetingStatus == '') {
                       swal("Sorry", 'Status must be select.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.meetingAddress == '') {
                        swal("Sorry", 'Meeting address must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.meetingAgenda == '') {
                        swal("Sorry", 'Meeting agenda must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.meetingAddress == '') {
                        swal("Sorry", 'Meeting address must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.cekAttendError('Asani') > 0) {
                        swal("Sorry", 'Asani Attendant must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.cekAttendError('Client') > 0) {
                        swal("Sorry", 'Client Attendant must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.companySince == '') {
                        swal("Sorry", 'Company since must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && (this.totalEmployeeClient == '' || this.totalEmployeeClient == 0)) {
                        swal("Sorry", 'Number of employee must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.industryType == '') {
                        swal("Sorry", 'Industry type must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.meetingResult == '') {
                        swal("Sorry", 'Meeting Result must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.listToDo == '') {
                        swal("Sorry", 'List to do must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 2 && this.meetingSchedule == '') {
                        swal("Sorry", 'Schedule must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 2 && this.meetingPlace == '') {
                        swal("Sorry", 'Place must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 2 && this.noteMeeting == '') {
                        swal("Sorry", 'Note must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 2 && this.reasonMeeting == '') {
                        swal("Sorry", 'Reason must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 99 && this.reasonMeeting == '') {
                        swal("Sorry", 'Reason must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else{
                        let sendEmail = false
                        if (x=='send') {
                            sendEmail = true
                            this.loadingButtonSaveSend = true
                        }else{
                            this.loadingButtonSave = true
                        }
                        
                        let asaniAttend = []
                        let clientAttend = []
                        let detail = {
                            address: this.meetingAddress,
                            agenda: this.meetingAgenda,
                            companySince: this.companySince,
                            numberOfEmployee: this.totalEmployeeClient,
                            industryType:this.industryType,
                            result: this.meetingResult,
                            listToDo: this.listToDo
                        }
                        for (var i = 0; i < this.inputAsaniAttend.length; i++) {
                            asaniAttend.push({
                                name:this.employeeName[i],
                                position:this.employeePosition[i]
                            })
                        }
                        for (var i = 0; i < this.inputClientAttend.length; i++) {
                            clientAttend.push({
                                name:this.clientName[i],
                                position:this.clientPosition[i]
                            })
                        }
                        this.$http.post(process.env.UPDATE_MEETING,{
                            reschedule: this.dateToString(this.meetingSchedule,false),
                            note: this.noteMeeting.replace(this.spaceRegex, ' '),
                            place: this.meetingPlace.replace(this.spaceRegex, ' '),
                            lastStatus: parseInt(this.lastStatus),
                            newStatus: this.meetingStatus,
                            reason: this.reasonMeeting.replace(this.spaceRegex, ' '),
                            companyId: this.companyId,
                            newCompany: this.newCompany,
                            asaniAttend: asaniAttend,
                            clientAttend: clientAttend,
                            detail: detail,
                            sendEmail:sendEmail,
                            visitDocumentation: this.visitDocumentation
                        },{
                            headers: {'Asani-Token':localStorage.getItem('jwt')}
                        })
                        .then(response => {
                            if (response.data.status === 200) {
                                swal("Success", response.data.message , "success", {
                                    button: "Ok",
                                })
                                this.meetingStatus = ''
                                this.meetingSchedule = ''
                                this.meetingPlace = ''
                                this.noteMeeting = ''
                                this.reasonMeeting = ''
                                this.loadingButtonSave = false
                                this.loadingButtonSaveSend = false
                                this.getData()
                            }else if (response.data.status == 400) {
                                swal("Sorry", response.data.message , "error", {
                                    button: "Ok",
                                })
                            }                
                            this.loadingButtonSave = false
                            $('#modalMeeting').modal('hide')
                        })
                        .catch(error => {
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                    }
                }else{
                    if (this.meetingAddress == '') {
                        swal("Sorry", 'Meeting address must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingAgenda == '') {
                        swal("Sorry", 'Meeting agenda must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingAddress == '') {
                        swal("Sorry", 'Meeting address must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.cekAttendError('Asani') > 0) {
                        swal("Sorry", 'Asani Attendant must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.cekAttendError('Client') > 0) {
                        swal("Sorry", 'Client Attendant must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.companySince == '') {
                        swal("Sorry", 'Company since must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.totalEmployeeClient == '' || this.totalEmployeeClient == 0) {
                        swal("Sorry", 'Number of employee must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.industryType == '') {
                        swal("Sorry", 'Industry type must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingResult == '') {
                        swal("Sorry", 'Meeting Result must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.listToDo == '') {
                        swal("Sorry", 'List to do must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else{
                        let sendEmail = false
                        if (x=='send') {
                            sendEmail = true
                            this.loadingButtonSaveSend = true
                        }else{
                            this.loadingButtonSave = true
                        }
                        
                        let asaniAttend = []
                        let clientAttend = []
                        let detail = {
                            address: this.meetingAddress,
                            agenda: this.meetingAgenda,
                            companySince: this.companySince,
                            numberOfEmployee: this.totalEmployeeClient,
                            industryType:this.industryType,
                            result: this.meetingResult,
                            listToDo: this.listToDo
                        }
                        for (var i = 0; i < this.inputAsaniAttend.length; i++) {
                            asaniAttend.push({
                                name:this.employeeName[i],
                                position:this.employeePosition[i]
                            })
                        }
                        for (var i = 0; i < this.inputClientAttend.length; i++) {
                            clientAttend.push({
                                name:this.clientName[i],
                                position:this.clientPosition[i]
                            })
                        }
                        this.$http.post(process.env.UPDATE_MEETING,{
                            reschedule: this.dateToString(this.meetingSchedule,false),
                            note: this.noteMeeting.replace(this.spaceRegex, ' '),
                            place: this.meetingPlace.replace(this.spaceRegex, ' '),
                            lastStatus: parseInt(this.lastStatus),
                            newStatus: this.meetingStatus,
                            reason: this.reasonMeeting.replace(this.spaceRegex, ' '),
                            companyId: this.companyId,
                            newCompany: this.newCompany,
                            asaniAttend: asaniAttend,
                            clientAttend: clientAttend,
                            detail: detail,
                            sendEmail:sendEmail,
                            visitDocumentation: this.visitDocumentation
                        },{
                            headers: {'Asani-Token':localStorage.getItem('jwt')}
                        })
                        .then(response => {
                            if (response.data.status === 200) {
                                swal("Success", response.data.message , "success", {
                                    button: "Ok",
                                })
                                this.meetingStatus = ''
                                this.meetingSchedule = ''
                                this.meetingPlace = ''
                                this.noteMeeting = ''
                                this.reasonMeeting = ''
                                this.loadingButtonSave = false
                                this.loadingButtonSaveSend = false
                                this.getData()
                            }else if (response.data.status == 400) {
                                swal("Sorry", response.data.message , "error", {
                                    button: "Ok",
                                })
                            }                
                            this.loadingButtonSave = false
                            $('#modalMeeting').modal('hide')
                        })
                        .catch(error => {
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                    }
                }
            }else{
                if (this.meetingSchedule == '') {
                    swal("Sorry", 'Schedule must be select.' , "error", {
                      button: "Close",
                    })
                }else if (this.meetingPlace == '') {
                    swal("Sorry", "Place must be fill" , "error", {
                    button: "Ok",
                })
                }else if (this.noteMeeting == '') {
                    swal("Sorry", "Note must be fill" , "error", {
                        button: "Ok",
                    })
                }else{
                    this.loadingButtonSave = true
                    this.$http.post(process.env.UPDATE_MEETING,{
                        schedule: this.dateToString(this.meetingSchedule,false),
                        note: this.noteMeeting.replace(this.spaceRegex, ' '),
                        place: this.meetingPlace.replace(this.spaceRegex, ' '),
                        lastStatus: parseInt(this.lastStatus),
                        companyId: this.companyId,
                        newCompany: this.newCompany,
                        sendEmail:false
                    },{
                        headers: {'Asani-Token':localStorage.getItem('jwt')}
                    })
                    .then(response => {
                        if (response.data.status === 200) {
                            swal("Success", response.data.message , "success", {
                                button: "Ok",
                            })
                            this.meetingSchedule = ''
                            this.meetingPlace = ''
                            this.noteMeeting = ''
                            this.reasonMeeting = ''
                            this.loadingButtonSave = false
                            this.getData()
                        }else if (response.data.status == 400) {
                            swal("Sorry", response.data.message , "error", {
                                button: "Ok",
                            })
                        }                
                        this.loadingButtonSave = false
                        $('#modalMeeting').modal('hide')
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
                }
            }
        },
        submitContacting(){
            if (this.channel == '') {
                swal("Sorry", "Channel must be choose" , "error", {
                    button: "Ok",
                })
            }else if (this.contactingDate == '') {
                swal("Sorry", "Date must be fill" , "error", {
                    button: "Ok",
                })
            }else if (this.noteContacting == '') {
                swal("Sorry", "Notes must be fill" , "error", {
                    button: "Ok",
                })
            }else{
                this.loadingButtonSave = true
                this.$http.post(process.env.INSERT_CONTACTING,{
                    channel: this.channel,
                    date: this.dateToString(this.contactingDate,false),
                    note: this.noteContacting.replace(this.spaceRegex, ' '),
                    companyId: this.companyId,
                    newCompany: this.newCompany
                },{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status === 200) {
                        swal("Success", response.data.message , "success", {
                            button: "Ok",
                        })
                        this.channel = ''
                        this.noteContacting = ''
                        this.contactingSchedule = ''
                        this.loadingButtonSave = false
                        this.getData()
                    }else if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }                
                    this.loadingButtonSave = false
                    $('#modalContacting').modal('hide')
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }
        },
        submitChangePicAsani(){
            if (this.employeeAsani['id'] == '') {
                swal("Sorry", "PIC must be choose" , "error", {
                    button: "Ok",
                })
            }else{
                this.loadingButtonSave = true
                this.$http.post(process.env.EDIT_ASANI_PIC_COMPANY,{
                    id: this.employeeAsani['id'],
                    companyId: this.companyId,
                    newCompany: this.newCompany
                },{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status === 200) {
                        swal("Success", response.data.message , "success", {
                            button: "Ok",
                        })
                        this.employeeAsani = {
                            id : '',
                            employeeName:''
                        }
                        this.loadingButtonSave = false
                        this.getData()
                    }else if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }                
                    this.loadingButtonSave = false
                    $('#modalEditAsaniPIC').modal('hide')
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }
        },
        submitChangeSalesStatus(){
            // console.log(this.chooseSalesStatus['status'])
            if (this.chooseSalesStatus['status'].toString() == '') {
                // console.log('ini')
                swal("Sorry", "Status must be choose" , "error", {
                    button: "Ok",
                })
            }else{
                this.loadingButtonSave = true
                this.$http.post(process.env.EDIT_SALES_STATUS,{
                    status: this.chooseSalesStatus['status'],
                    companyId: this.companyId,
                    newCompany: this.newCompany
                },{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status === 200) {
                        swal("Success", response.data.message , "success", {
                            button: "Ok",
                        })
                        this.chooseSalesStatus = {
                            status : '',
                            statusName:''
                        }
                        this.loadingButtonSave = false
                        this.getData()
                    }else if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }                
                    this.loadingButtonSave = false
                    $('#modalEditSalesStatus').modal('hide')
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }
        },
        sendLog(w,x,y){
            var today = new Date();
            var month = today.getMonth()+1
            if (month < 10) {
                month = '0'+month
            }
            var dateDay = today.getDate()
            if (dateDay < 10) {
                dateDay = '0'+dateDay
            }
            var hours = today.getHours()
            if (hours < 10) {
                hours = '0'+hours
            }
            var minutes = today.getMinutes()
            if (minutes < 10) {
                minutes = '0'+minutes
            }
            var second = today.getSeconds()
            if (second < 10) {
                second = '0'+second
            }
            var date = today.getFullYear()+'-'+month+'-'+dateDay;
            var time = hours + ":" + minutes + ":" + second;
            var dateTime = date+' '+time;
            var admin = this.admin
            var command = 'add-logs'
            // var productName = this.productNameChoose
            
            this.$http.post(process.env.LOG_URL+"/"+y+"/"+x,{
                codeLogs: w,
                params: [],
            },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                this.connectLogLessee()
                this.connectLogCompany()
            })
            .catch(error => {
                console.log(error)
            })
        },
        connectLogLessee:function(){
            var lesseeId = this.picId
            this.$http.get(process.env.LOG_URL+"/lessee/"+lesseeId,{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status === 200) {
                    this.dataLog = response.data.content
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        getLogLessee(data){
            this.logLessee = data
        },
        connectLogCompany:function(){
            var companyId = this.companyId
            this.$http.get(process.env.LOG_URL+"/company/"+companyId,{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status === 200) {
                    this.dataLog = response.data.content
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        getLogCompany(data){
            this.logCompany = data
        },
        getKabkot(x){
            this.$http.post(process.env.API_GET_KABKOT, {
                provinceId: this.editProvince.provinceId,
            },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status == 200) {
                    this.kabkot = response.data.content
                    if (x == 'ada') {
                        this.editKabKot = ''
                        this.editKecamatan = ''
                    }
                }
            })
            .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        getKecamatan(x) {
            this.$http.post(process.env.API_GET_KECAMATAN, {
                kabKotId: this.editKabKot.kabKotId,
            },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status == 200) {
                    this.kecamatan = response.data.content
                    if (x == 'ada') {
                        this.editKecamatan = ''
                    }
                }
            })
            .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        pickFile() {
            this.$refs.doc.click()
        },
        onFilePicked(e, type) {
            const files = e.target.files
            if (files[0] !== undefined) {
                if (files[0].size > 10 * 1024 * 1024) {
                    swal("Sorry", 'File size must be less than 10 MB' , "error", {
                        button: "Ok",
                    })
                    this.$refs[type].value = null;
                    return;
                }
                this.docFileName = files[0].name
                if (this.docFileName.lastIndexOf('.') <= 0) {
                    return
                }
                const fr = new FileReader()
                fr.readAsDataURL(files[0])
                fr.addEventListener('load', () => {
                    this.docUrl = fr.result
                    this.docFile = files[0] // this is an image file that can be sent to server...
                    this.docBase64 = fr.result.split("base64,")[1]
                    if (this.docFileName.toLowerCase().includes(".png") || this.docFileName.toLowerCase().includes(".jpeg") || this.docFileName.toLowerCase().includes(".jpg")) {
                        // this.PurchaseView = true
                    } 
                    // else this.PurchaseView = false
                    // if (this.docFile.size >= 2000000) {
                    //     this.docFileName = ''
                    //     this.docFile = ''
                    //     this.docUrl = ''
                    //     swal("Ukuran file tidak boleh lebih dari 2MB", "", "warning", {
                    //             buttons: {
                    //                 agree: "OK",
                    //             },
                    //         })
                    //         .then((value) => {
                    //             this.pickFile()
                    //         });
                    // }
                })
            } else {
                this.docFileName = ''
                this.docFile = ''
                this.docUrl = ''
            }
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        submitDoc(){
            if (this.docFileName == '') {
                swal("Sorry", "File must be choose" , "error", {
                    button: "Ok",
                })
            }else if (this.docPilih == 'Akta' && this.aktaAdressInput == '') {
                swal("Sorry", "Akta address must be fill" , "error", {
                    button: "Ok",
                })
            }else if (this.docPilih == 'KTP' && this.uploadKTPNumber == '') {
                swal("Sorry", "KTP number must be fill" , "error", {
                    button: "Ok",
                })
            }else if (this.docPilih == 'KTP' && this.citizenship === 'wni' && this.uploadKTPNumber.length != 16) {
                swal("Sorry", "KTP number must be 16 digit" , "error", {
                    button: "Ok",
                })
            }else{
                let self = this
                this.loadingButtonSave = true
                const documentType = this.docPilih === "KTP"? "KTP/Passport": this.docPilih
                let docs = { type: documentType, docFileName: this.docFileName, docBase64: this.docBase64 }
                this.$http.post(process.env.UPDATE_DOC_LESSEE,{
                    docId: this.docId,
                    dataDocument: [docs],
                    note: this.noteChangeDocument !== null ? this.noteChangeDocument.replace(this.spaceRegex, ' ') : this.noteChangeDocument,
                    adminId: this.adminId,
                    newCompany: this.newCompany,
                    companyNameNPWP: this.companyNameNPWPInput !== null ? this.companyNameNPWPInput.replace(this.spaceRegex, ' ') : this.companyNameNPWPInput,
                    npwpNumber: this.NpwpDocInput !== null ? this.NpwpDocInput.replace(this.spaceRegex, ' ') : this.NpwpDocInput,
                    aktaAddress: this.aktaAdressInput !== null ? this.aktaAdressInput.replace(this.spaceRegex, ' ') : this.aktaAdressInput,
                    ktpPassportNumber: this.uploadKTPNumber !== null ? this.uploadKTPNumber.replace(this.spaceRegex, ' ') : this.uploadKTPNumber
                },{
                    timeout: 120 * 1000,
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status === 200) {
                        swal("Success", response.data.message , "success", {
                            button: "Ok",
                        })
                        if (this.docPilih == 'KTP') {
                            this.sendLog(12,this.companyId,'company')
                        }else if (this.docPilih == 'Akta') {
                            this.sendLog(10,this.companyId,'company')
                        }else if (this.docPilih == 'SIUP') {
                            this.sendLog(11,this.companyId,'company')
                        }else if (this.docPilih == 'SK Menkumham') {
                            this.sendLog(106,this.companyId,'company')
                        }
                        this.noteChangeDocument = ''
                        this.docFileName = ''
                        this.docFile = ''
                        this.docUrl = ''
                        this.loadingButtonSave = false
                        this.getData()
                        document.getElementById("change_document").value = null;
                    }else if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }else{
                        swal("Upload Failed", "Max size doc 10MB or Please check your connection", "error", {
                              button: "Ok",
                        })
                    }                
                    this.loadingButtonSave = false
                    this.docFileName = ''
                    this.docBase64 = ''
                    $('#modalChangeDocument').modal('hide')
                    document.getElementById('change_document').value = null
                })
                .catch(error => {
                    self.loadingButtonSave = false
                    if (error.response) {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    } else {
                        if (!error.status) {
                            self.loadingButtonSave = false
                            self.docFileName = ''
                            self.docBase64 = ''
                            $('#modalChangeDocument').modal('hide')
                            document.getElementById('change_document').value = null
                            swal("Upload Failed", "Please check your connection", "error", {
                                button: "Ok",
                            })
                        }
                    }
                    this.loadingButtonSave = false;
                })
            }
        },
        submitEditPic(){
            if (this.editUserName == '') {
                swal("Sorry", "User name must be fill" , "error", {
                    button: "Ok",
                })
            }else if (this.editUserPhone.substring(0,3) != '628' || this.editUserPhone == '') {
                swal("Sorry", "Phone number must be fill or first of three character must '628'" , "error", {
                    button: "Ok",
                })
            }else{
                this.loadingButtonSave = true
                this.$http.post(process.env.EDIT_PIC,{
                    userId: this.picId,
                    userName: this.editUserName !== null ? this.editUserName.replace(this.spaceRegex, ' ') : this.editUserName,
                    phoneNumber: this.editUserPhone !== null ? this.editUserPhone.replace(this.spaceRegex, ' ') : this.editUserPhone,
                    email: this.editUserEmail !== null ? this.editUserEmail.replace(this.spaceRegex, ' ') : this.editUserEmail,
                    position: this.editUserPosition !== null ? this.editUserPosition.replace(this.spaceRegex, ' ') : this.editUserPosition,
                    division: this.editUserDivision !== null ? this.editUserDivision.replace(this.spaceRegex, ' ') : this.editUserDivision,
                    adminId: this.adminId,
                    newCompany: this.newCompany
                },{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status === 200) {
                        swal("Success", response.data.message , "success", {
                            button: "Ok",
                        })
                        if (response.data.content.newName) {
                            this.sendLog(53,this.picId,'lessees')
                        }
                        if (response.data.content.newPhone) {
                            this.sendLog(54,this.picId,'lessees')
                        }
                        if (response.data.content.newDivision) {
                            this.sendLog(57,this.picId,'lessees')
                        }
                        if (response.data.content.newPosition) {
                            this.sendLog(56,this.picId,'lessees')
                        }
                        if (response.data.content.newEmail) {
                            this.sendLog(55,this.picId,'lessees')
                        }
                        this.loadingButtonSave = false
                    }else if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }else if (response.data.status == 201) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }                  
                    $('#modalEditPIC').modal('hide')
                    this.loadingButtonSave = false
                    this.getData()
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }
        },
        ValidateFileUpload() {
            var fuData = document.getElementById('file_foto_rent');
            var FileUploadPath = fuData.value;
            if (FileUploadPath == '') {
                alert("Please upload an image");
            } else {
                var Extension = FileUploadPath.substring(
                FileUploadPath.lastIndexOf('.') + 1).toLowerCase();
                if (Extension =="png" || Extension =="jpg") {
                    if (fuData.files && fuData.files[0]) {
                        var reader = new FileReader();
                        reader.onload = function(e) {
                            $('#show_img_rent').attr('src', e.target.result);
                        }
                        reader.readAsDataURL(fuData.files[0]);
                    }
                }else {
                    alert("Photo only allows file types of PNG.");
                    document.getElementById("file_foto_rent").value ="";
                      // document.getElementById("show_img_"+index).src = './images/no-image-icon-23485.png';
              }
            }
        },
        openModal(x,y,z) {
            this.docPilih = y
            let error = 0
            if (x == 'DocPending') {
                this.rejectReason = ''
                this.aktaAdressInput = this.aktaAddress
                this.NpwpDocInput = this.companyNPWP
                this.KTPNumber = this.companyKtpPassportNumber
                this.docStatus = z
                this.docId = this.companyId
                this.loadingTableDoc = true
                this.$http.post(process.env.GET_HISTORY_DOC,{
                  docType: this.docPilih,
                  docId: Number(this.docId),
                  newUser: this.newCompany
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }
                  this.historyDocData = response.data.content
                  this.loadingTableDoc = false
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }else if(x == 'ChangeDocument'){
                this.docId = this.companyId
                this.NpwpDocInput = ''
                this.aktaAdressInput = ''
            }else if(x == 'EditCompany'){
                this.editProvince = this.apiProvince
                if (this.editProvince != '') {
                    this.getKabkot()                    
                }
                this.editKabKot = this.apiKabKot
                this.kabkot = this.apiDataKabkot
                if (this.editKabKot != '') {
                    this.getKecamatan()
                }
                this.editKecamatan = this.apiKecamatan
                this.kecamatan = this.apiDataKecamatan
                this.editCompanyNpwp = this.companyNPWP
            }else if (x == 'Meeting') {
                if (this.lastStatus == 1) {
                    this.meetingAddress = this.editMeetingAddress
                    this.meetingAgenda = this.editMeetingAgenda
                    this.inputAsaniAttend = []
                    this.inputClientAttend = []
                    this.employeeName=[]
                    this.employeePosition=[]
                    this.clientName =[]
                    this.clientPosition=[]
                    for (var i = 0; i < this.editInputAsaniAttend.length; i++) {
                            this.inputAsaniAttend.push([''])
                            this.employeeName.push(this.editEmployeeName[i])
                            this.employeePosition.push(this.editEmployeePosition[i])
                    }
                    for (var i = 0; i < this.editInputClientAttend.length; i++) {
                            this.inputClientAttend.push([''])
                            this.clientName.push(this.editClientName[i])
                            this.clientPosition.push(this.editClientPosition[i])
                    }
                    this.meetingResult = this.editMeetingResult
                    this.listToDo = this.editListToDo
                }
                this.editMeeting = false
                this.loadingButton = true
                this.$http.post(process.env.CEK_COMPANY_STATUS,{
                  companyId: this.companyId,
                  newCompany: this.newCompany
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }else{
                        if (response.data.data.companyStatus < 1 || response.data.data == null || response.data.data.companyStatus == null) {
                            swal("Sorry", 'You must follow step KYC lessee' , "error", {
                                button: "Ok",
                            })  
                        }else{
                            $("#modal"+x).modal('show')
                        }
                    }
                    this.loadingButton = false
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }else if (x == 'UploadLegalDocument') {
                this.loadingButton = true
                this.$http.post(process.env.CEK_COMPANY_STATUS,{
                  companyId: this.companyId,
                  newCompany: this.newCompany
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }else{
                        if (response.data.data.companyStatus < 3 || response.data.data == null || response.data.data.companyStatus == null) {
                            swal("Sorry", 'You must follow step KYC lessee' , "error", {
                                button: "Ok",
                            })  
                        }else{
                            if (this.companyStatus < 4) {
                                $("#modal"+x).modal('show')
                            } 
                        }
                    }
                    this.loadingButton = false
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }
            if (x != 'UploadLegalDocument' && x != 'SendAgreement' && x != 'ProcessAgreement' && x != 'UpdateStatus' && x != 'Meeting'){
                if (y === 'NPWP/SKT') {
                    $('#modalChangeStatusNPWPDoc').modal('show')
                } else {
                    $("#modal"+x).modal('show')
                }
            }
        },
        viewAll(x){
            this.$router.push('/order/search')
            localStorage.setItem('companyName', x)
            localStorage.setItem('orderId',"")
            localStorage.setItem('statusOrder',"")
        },
        toPage(e) {
            this.$router.push(e)
        },
        cekLogin(){
            if (localStorage.getItem('jwt') == null) {
                this.$router.push('/')
            }
        },
        async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
            localStorage.removeItem('jwt')
            localStorage.removeItem('admin_name')
            localStorage.removeItem('roles')
            localStorage.removeItem('user_email')
            localStorage.removeItem('admin_id')
            localStorage.removeItem('endrent_cache')
            localStorage.removeItem('changeCatalogPermission')
            this.$router.push('/')
        },
        sidebar(){
            $("#wrapper").toggleClass("toggled");
        },
        close() {
            this.$emit('close');
        },
        cekPermission(){
          this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
          for(var i=0; i < this.permission.length; i++){
            if( this.permission[i] == "1"){
              this.viewDashboard = true
            }
            if( this.permission[i] == "2.1"){
              this.viewOrder = true
            }
            if( this.permission[i] == "2.2"){
              this.editOrder = true
            }
            if( this.permission[i] == '3.1'){
              this.viewReturn = true
            }
            if( this.permission[i] == '3.2'){
              this.editReturn = true
            }
            if( this.permission[i] == '4.1'){
              this.viewProduct = true
            }
            if( this.permission[i] == '4.2'){
              this.editProduct = true
            }
            if( this.permission[i] == '5.1'){
              this.viewPairing = true
            }
            if( this.permission[i] == '5.2'){
              this.editPairing = true
            }
            if( this.permission[i] == '6'){
              this.viewReconcile = true
            }
            if( this.permission[i] == '7.1'){
              this.viewResolution = true
            }
            if( this.permission[i] == '7.2'){
              this.editResolution = true
            }
            if( this.permission[i] == '8.1'){
              this.viewLessor = true
            }
            if( this.permission[i] == '8.2'){
              this.editLessor = true
            }
            if( this.permission[i] == '9.1'){
              this.viewLessee = true
            }
            if( this.permission[i] == '9.2'){
              this.editLessee = true
            }
            if( this.permission[i] == '10'){
              this.viewEmployee = true
            }
            if( this.permission[i] == '11.1'){
              this.viewLesseeVerification = true
            }
          }
          if (this.viewLesseeVerification == false) {
            this.$router.push('/')
          }
        },
        searchData(){
            if (this.assignDeposit == 1) {
                if (this.Deposit != 0) {
                    this.$http.post(process.env.TES,{
                        orderId: this.orderId,
                        Deposit: this.Deposit,
                        productOrder: this.inputs
                    },{
                        headers: {'Asani-Token':localStorage.getItem('jwt')}
                    })
                    .then(response => {
                        this.dataOrder = response.data.content.data
                        this.totalPage = response.data.content.totalPage
                        this.totalData = response.data.content.totalData
                        this.currentPage = response.data.content.currentPage
                        localStorage.setItem('companyName', this.companyName)
                        localStorage.setItem('orderId', this.orderId)
                        localStorage.setItem('statusOrder', this.statusOrder)
                      // this.$router.push('/order/search')
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
                }
            }
        },
        getData(){
            this.companyId = this.$route.params.companyId
            this.$http.post(process.env.DETAIL_LESSEE_DOCUMENTS,{
                  companyId: this.companyId,
                  companyStatus: this.$route.query.companyStatus
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
              .then(response => {
                this.lesseeDetailData = response.data.data
                this.dataPayment = response.data.data.dataPayment
                this.newCompany = response.data.data.newCompany
                this.rejectCompanyReason = response.data.data.detailLessee[0].rejectReason
                this.asaniEmployeeName = response.data.data.detailLessee[0].employeeName
                if (response.data.data.detailLessee[0].employeeName != null) {
                    this.employeeAsani['employeeName'] = response.data.data.detailLessee[0].employeeName
                    this.employeeAsani['id'] = response.data.data.detailLessee[0].idEmployee
                }
                this.salesStatus = response.data.data.detailLessee[0].salesStatus
                if (response.data.data.detailLessee[0].salesStatus != null) {
                    this.chooseSalesStatus['status'] = response.data.data.detailLessee[0].salesStatus
                    this.chooseSalesStatus['statusName'] = response.data.data.detailLessee[0].salesStatusName
                }
                
                this.companyNameNPWP = response.data.data.detailLessee[0].companyNameNPWP
                this.companyName = response.data.data.detailLessee[0].companyName
                this.getNPWPName = response.data.data.detailLessee[0].npwpFileName
                this.getKtpName = response.data.data.detailLessee[0].ktpFileName
                this.getSiupName = response.data.data.detailLessee[0].siupFileName
                this.getAktaName = response.data.data.detailLessee[0].aktaFileName
                this.getSKName = response.data.data.detailLessee[0].skFileName
                this.companyStatus = response.data.data.detailLessee[0].companyStatus
                this.companyAddress = response.data.data.detailLessee[0].companyAddress
                this.companyPhone = response.data.data.detailLessee[0].companyPhone
                this.companyFax = response.data.data.detailLessee[0].companyFax
                this.picId = response.data.data.detailLessee[0].userId
                this.userName = response.data.data.detailLessee[0].userName
                this.companyKtpPassportNumber = response.data.data.detailLessee[0].companyKtpPassportNumber
                this.citizenship = response.data.data.detailLessee[0].citizenship
                this.userPhone = response.data.data.detailLessee[0].userPhone
                this.userEmail = response.data.data.detailLessee[0].userEmail
                this.userPosition = response.data.data.detailLessee[0].userPosition
                this.userDivision = response.data.data.detailLessee[0].userDivision
                this.companyKTPStatus = response.data.data.detailLessee[0].companyKTPStatus
                this.editUserName = response.data.data.detailLessee[0].userName
                this.editUserKTP = response.data.data.detailLessee[0].companyKTPNumber
                this.editUserPhone = response.data.data.detailLessee[0].userPhone
                this.editUserEmail = response.data.data.detailLessee[0].userEmail
                this.editUserPosition = response.data.data.detailLessee[0].userPosition
                this.editUserDivision = response.data.data.detailLessee[0].userDivision
                this.companyKTPStatus = response.data.data.detailLessee[0].companyKTPStatus
                // this.NPWPStatus = response.data.data.detailLessee[0].NPWPStatus
                this.aktaAddress = response.data.data.detailLessee[0].aktaAddress
                this.source = response.data.data.detailLessee[0].source
                this.companyNPWP = response.data.data.detailLessee[0].companyNPWP
                this.companyNPWP16 = response.data.data.detailLessee[0].companyNPWP16
                this.companyNPWP22 = response.data.data.detailLessee[0].companyNPWP22
                // this.siupStatus = response.data.data.detailLessee[0].siupStatus
                // this.SKStatus = response.data.data.detailLessee[0].SKStatus
                // this.aktaStatus = response.data.data.detailLessee[0].aktaStatus
                this.companyId = response.data.data.detailLessee[0].companyId
                this.companyLogoUrl = response.data.data.detailLessee[0].companyLogoUrl
                this.companyKTPUrl = response.data.data.detailLessee[0].companyKTPUrl
                this.NPWPUrl = response.data.data.detailLessee[0].NPWPUrl
                this.siupUrl = response.data.data.detailLessee[0].siupUrl
                this.SKUrl = response.data.data.detailLessee[0].SKUrl
                this.aktaUrl = response.data.data.detailLessee[0].aktaUrl
                this.editCompanyFax = response.data.data.detailLessee[0].companyFax
                this.editCompanyPhone = response.data.data.detailLessee[0].companyPhone
                this.editSource = response.data.data.detailLessee[0].source
                this.editCompanyAddress = response.data.data.detailLessee[0].companyAddress
                this.editAktaAddress = response.data.data.detailLessee[0].aktaAddress
                this.aktaAdressInput = response.data.data.detailLessee[0].aktaAddress
                this.editCompanyName = response.data.data.detailLessee[0].companyName
                if(response.data.data.detailLessee[0].companyProvince != null){
                    this.apiProvince = {
                        provinceId: response.data.data.province[0].provinceId,
                        provinceName: response.data.data.province[0].provinceName,
                    }
                    // this.getKabkot()
                    this.companyProvince = response.data.data.province[0].provinceName
                }
                this.editKabKot = response.data.data.detailLessee[0].companyKabkot
                if(response.data.data.detailLessee[0].companyKabkot != null){
                    this.apiKabKot = {
                        kabKotId: response.data.data.kabkot[0].kabKotId,
                        kabKotName: response.data.data.kabkot[0].kabKotName,
                    }
                    // this.getKecamatan()
                    this.companyCity = response.data.data.kabkot[0].kabKotName
                }
                this.editKecamatan = response.data.data.detailLessee[0].companyKecamatan
                if(response.data.data.detailLessee[0].companyKecamatan != null){
                    this.apiKecamatan = {
                        kecamatanId: response.data.data.kecamatan[0].kecamatanId,
                        kecamatanName: response.data.data.kecamatan[0].kecamatanName,
                    }
                    this.companyDistrict = response.data.data.kecamatan[0].kecamatanName
                }
                this.editKelurahan = response.data.data.detailLessee[0].companyKelurahan
                this.companyVillage = response.data.data.detailLessee[0].companyKelurahan
                this.companyZip = response.data.data.detailLessee[0].companyZip
                this.editZip = response.data.data.detailLessee[0].companyZip
                
                this.loadingTable =false
                this.docApprove=0
                this.connectLogLessee()
                this.connectLogCompany()
              })
              .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
              })
              var newCompany = false
              if(this.$route.query.companyStatus=='new'){
                newCompany = true
              }
              return this.getHistoryDoc('NPWP/SKT', newCompany)
              .then(() => {
                  return this.getHistoryDoc('SIUP', newCompany)
              })
              .then(() => {
                  return this.getHistoryDoc('Akta', newCompany)
              })
              .then(() => {
                  return this.getHistoryDoc('Akta Perubahan', newCompany)
              })
              .then(() => {
                  return this.getHistoryDoc('KTP/Passport', newCompany)
              })
              .then(() => {
                  return this.getHistoryDoc('SK Menkumham', newCompany)
              })
              .then(() => {
                  return this.getHistoryDoc('SK Menkumham Perubahan', newCompany)
              })
              .then(() => {
                this.loadingTableNpwp = false
                this.loadingTableAkta = false 
                this.loadingTableKtp = false
                this.loadingTableSiup = false
                this.loadingTableSk = false
                return this.$http.get(process.env.API_GET_PROVINCE,{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
              })
              .then(response => {
                if (response.data.status == 200) {
                    this.province = response.data.content
                }
                return this.$http.get(process.env.GET_LESSEE_SOURCE,{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
              })  
              .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message, "error", {
                        button: "Ok",
                    })
                } else {
                  this.sourceSelect = response.data.data
                }
              })
              .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
              })
                
                
          },
        getHistoryDoc(type, newCompany) {
            return new Promise((resolve, reject) => {
                this.$http.post(process.env.GET_HISTORY_DOC,{
                  docType: type,
                  docId: Number(this.companyId),
                  newUser: newCompany
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    } else if (response.data.status == 200) {
                        if(type == 'NPWP/SKT') {
                            this.historyNpwp = response.data.content
                            if(response.data.content.length > 0) {
                                this.NPWPStatus = response.data.content[0].docStatus
                            }
                            
                            this.loadingStatusNPWP = false
                        } else if (type == 'Akta') {
                            this.historyAkta = response.data.content
                            if(response.data.content.length > 0) {
                                this.aktaStatus = response.data.content[0].docStatus
                            }
                            this.loadingStatusAkta = false
                            
                        } else if(type == 'Akta Perubahan') {
                            this.historyAktaPerubahan = response.data.content
                            if(response.data.content.length > 0) {
                                this.aktaPerubahanStatus = response.data.content[0].docStatus
                            }
                            this.loadingStatusAktaPerubahan = false
                            
                        } else if(type == 'KTP/Passport') {
                            this.historyKtp = response.data.content
                            if(response.data.content.length > 0) {
                                this.companyKTPStatus = response.data.content[0].docStatus
                            }
                            this.loadingStatusKTP = false
                            
                        } else if(type == 'SIUP') {
                            this.historySiup = response.data.content
                            if(response.data.content.length > 0) {
                                this.siupStatus = response.data.content[0].docStatus
                            }
                            this.loadingStatusSiup = false

                        } else if (type == 'SK Menkumham') {
                            this.historySk = response.data.content
                            if(response.data.content.length > 0) {
                                this.SKStatus = response.data.content[0].docStatus
                            }
                            this.loadingStatusSK = false
                            
                        } else if (type == 'SK Menkumham Perubahan') {
                            this.historySkPerubahan = response.data.content
                            if(response.data.content.length > 0) {
                                this.SKPerubahanStatus = response.data.content[0].docStatus
                            }
                            this.loadingStatusSKPerubahan = false
                            
                        }
                        resolve(true)
                    }
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                    reject(error)
                })
            })
            
        }
    },
    created(){
      this.getData()
      this.admin = localStorage.getItem('admin_name')
      this.adminId = localStorage.getItem('admin_id')
      this.cekLogin()
      this.cekPermission()
    }
  }
</script>

<!-- Add"scoped" attribute to limit CSS to this component only -->
<style scoped>
.link-text{
    color: #2797FB;
}
.link-text:hover{
    color: #2797FB;
    cursor: pointer;
}
.font-red{
    color: red;
    /*margin-top: -15px;*/
}
.icon-verified {
    max-width: 22px;
    max-height: 22px;
    margin-right: 2px;
}
.edit-status{
    margin-bottom: 0
}
.permonth{ 
  margin: 5px 0px 5px 5px;
}
.text-partnership{
  margin-bottom: 0px;
}
.img-responsive{
  width: 250px;
  height: auto;
}
.process-vendor-new{
  max-width: 345px;
  margin: 5px 5px;
}
.process-qty-new{
  max-width: 62px;
  margin: 5px 5px;
}
.process-vendor{
  min-width: 345px;
  margin-bottom: 5px;
}
.process-qty{
  max-width: 62px;
}
.button-plus {
    position: absolute;
    bottom: 21px;
    right: 0px;
}
.input-title{
  margin: 0px 5px;
}
.input-one-line{
  display: flex;
}
.input-one-line-assign{
  display: flex;
  width: 100%;
}
.input-title-assign{
  margin: 0px 5px;
  width: 100%;
}
.input-title-qty{
  margin: 0px 5px;
  width: 100%;
}
.title-product{
  width: 100%;
  margin: 5px 0px;
}
.input-group-addon {
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1;
    color: #555;
    text-align: center;
    background-color: #eee;
    border: 1px solid #ccc;
    border-radius: 4px 0px 0px 4px;
    border-right: none;
}
.label-addon-rp{
  margin: 1px 0px;
}
.change-title{
  display: block;
}
.one-line{
  display: flex;
  margin: 5px 0px;
}
.one-line .ol-label-file{
  width: 130px;
  margin: 2px 0px;
}
.one-line .ol-titik2-file{
  width: 10px;
  margin: 2px 0px;
}
.one-line .ol-label{
  width: 188px;
  margin: 2px 0px;
}
.one-line .ol-label-reason{
  width: 88px;
  margin: 2px 0px;
}
.one-line .ol-label-price{
  width: 263px;
  margin: 2px 0px;
}
.one-line .ol-titik2{
  width: 15px;
  margin: 2px 0px;
}
.one-line .ol-titik2-price{
  margin: 2px 0px;
}
.one-line .ol-value{
  width: 100%;
  margin: 2px 0px;
}
.fixed_header{
  table-layout: fixed;
  border-collapse: collapse;
}
.fixed_header tbody{
  display:block;
  overflow:auto;
  height:200px;
  width:100%;
}
.fixed_header tbody.full-width tr td{
  width:1578px;
}
.fixed_header thead tr{
  display:block;
}
.fixed_header th, .fixed_header td {
  padding: 5px;
  text-align: left;
  width: 200px;
}
.fixed_header.payment th, .fixed_header.payment td {
  padding: 5px;
  text-align: left;
  width: 217px;
}
.pagination{
  padding: 0px 0;
}
.pagination ul{
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.pagination a{
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}
.p8 a{
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}
.p8 a:hover{
  text-decoration: none;
}
.p8 a.page:hover{
  text-decoration: none;
  color: #fff;
}
.p8 .is-active{
  background-color: #fff;
  color: #2797FB;
}
.alignleft {
  float: left;
}
.alignright {
  float: right;
}
.pagg{
  display: inline-flex;
  overflow:auto;
}
.total-data{
  font-size: 14px;
  color: #343A40;
}
#wrapperr{
  overflow:auto;
  margin: 5px 3px;
}
#c1{
 float:left;
}
#c2{
  float: right;  
}
/*.table td, .table th {
    padding: 0.25rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
    }*/
    .search-table{
      padding-bottom: 7px;
      margin-top: -5px;
      margin-left: -15px;
    }
    .active{
      color: #2797FB;
    }
    .right-dropdown{
      margin-left: 7px;
    }
    .account-div{
      margin: 2px 2px;
    }
    .right-arrow{
      margin-left: auto;
    }
    .brand-logo{
      width: 120px;
    }
    .menu-title{
      margin-left: 1.125rem;
    }
    .menu-title-order{
      margin-left: 1.95rem;
    }
    .menu-title-payment{
      margin-left: 1.525rem;
    }
    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      /*width: 200px;*/
      /*background-color: #f1f1f1;*/
    }
    li.sidebar a {
      display: block;
      color: #000;
      padding: 8px 63px;
      text-decoration: none;
    }
    li a.active {
      background-color: #4CAF50;
      color: white;
    }
    li a:hover:not(.active) {
      background-color: #2797FB;
      color: white;
    }
    .nav-side-menu {
      overflow: auto;
      font-family: verdana;
      font-size: 12px;
      font-weight: 200;
      background-color: #2e353d;
      position: fixed;
      top: 0px;
      width: 300px;
      height: 100%;
      color: #e1ffff;
    }
    .nav-side-menu .brand {
      background-color: #23282e;
      line-height: 50px;
      display: block;
      text-align: center;
      font-size: 14px;
    }
    .nav-side-menu .toggle-btn {
      display: none;
    }
    .nav-side-menu ul,
    .nav-side-menu li {
      list-style: none;
      padding: 0px;
      margin: 0px;
      line-height: 35px;
      cursor: pointer;
    }
    .nav-side-menu ul :not(collapsed) .arrow:before,
    .nav-side-menu li :not(collapsed) .arrow:before {
      font-family: FontAwesome;
      content:"\f078";
      display: inline-block;
      padding-left: 10px;
      padding-right: 10px;
      vertical-align: middle;
    }
    .nav-side-menu ul .active,
    .nav-side-menu li .active {
      border-left: 3px solid #d19b3d;
      background-color: #4f5b69;
    }
    .nav-side-menu ul .sub-menu li.active,
    .nav-side-menu li .sub-menu li.active {
      color: #d19b3d;
    }
    .nav-side-menu ul .sub-menu li.active a,
    .nav-side-menu li .sub-menu li.active a {
      color: #d19b3d;
    }
    .nav-side-menu ul .sub-menu li,
    .nav-side-menu li .sub-menu li {
      background-color: #181c20;
      border: none;
      line-height: 28px;
      border-bottom: 1px solid #23282e;
      margin-left: 0px;
    }
    .nav-side-menu ul .sub-menu li:hover,
    .nav-side-menu li .sub-menu li:hover {
      background-color: #020203;
    }
    .nav-side-menu ul .sub-menu li:before,
    .nav-side-menu li .sub-menu li:before {
      font-family: FontAwesome;
      content:"\f105";
      display: inline-block;
      padding-left: 10px;
      padding-right: 10px;
      vertical-align: middle;
    }
    .nav-side-menu li {
      padding-left: 0px;
      border-left: 3px solid #2e353d;
      border-bottom: 1px solid #23282e;
    }
    .nav-side-menu li a {
      text-decoration: none;
      color: #e1ffff;
    }
    .nav-side-menu li a i {
      padding-left: 10px;
      width: 20px;
      padding-right: 20px;
    }
    .nav-side-menu li:hover {
      border-left: 3px solid #d19b3d;
      background-color: #4f5b69;
      -webkit-transition: all 1s ease;
      -moz-transition: all 1s ease;
      -o-transition: all 1s ease;
      -ms-transition: all 1s ease;
      transition: all 1s ease;
    }
    @media (max-width: 767px) {
      .nav-side-menu {
        position: relative;
        width: 100%;
        margin-bottom: 10px;
      }
      .nav-side-menu .toggle-btn {
        display: block;
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 10 !important;
        padding: 3px;
        background-color: #ffffff;
        color: #000;
        width: 40px;
        text-align: center;
      }
      .brand {
        text-align: left !important;
        font-size: 22px;
        padding-left: 20px;
        line-height: 50px !important;
      }
    }
    @media (min-width: 767px) {
      .nav-side-menu .menu-list .menu-content {
        display: block;
      }
    }
    @media (max-width: 573px){
      .mobile-div{
        padding: 2px 0px;
      }
    }
  </style>



// WEBPACK FOOTER //
// src/components/Partnership/LesseeDetailVerificationPage.vue